import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssetUrl: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Url: { input: any; output: any; }
};

/** Union type for Resume and Vacancy */
export type Ad = Resume | Vacancy;

export type AdBase = {
  activatable?: Maybe<Scalars['Boolean']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  awaitingPayment?: Maybe<Scalars['Boolean']['output']>;
  bumpedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  daysLeft?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draft: Scalars['Boolean']['output'];
  education?: Maybe<Scalars['String']['output']>;
  educationId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  experienceId?: Maybe<Scalars['ID']['output']>;
  expirable?: Maybe<Scalars['Boolean']['output']>;
  hits?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Invoice>;
  isBookmarked: Scalars['Boolean']['output'];
  isBumped?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isMine: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidServices: Array<PaidService>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  positionName?: Maybe<Scalars['String']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  relatedAds?: Maybe<Array<Ad>>;
  salaryFrom?: Maybe<Scalars['Int']['output']>;
  salaryTo?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vipAds?: Maybe<Array<Ad>>;
};

/** The connection type for Ad. */
export type AdConnection = {
  __typename?: 'AdConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ad>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AdDelete */
export type AdDeleteInput = {
  adType: AdTypeEnum;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdDelete. */
export type AdDeletePayload = {
  __typename?: 'AdDeletePayload';
  ad?: Maybe<Ad>;
  status: AdStatusEnum;
};

/** An edge in a connection. */
export type AdEdge = {
  __typename?: 'AdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Ad>;
};

export type AdFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  educationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  regionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  salaryFrom?: InputMaybe<Scalars['Int']['input']>;
  salaryTo?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  specializationByCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AdScopeEnum {
  All = 'ALL',
  Featured = 'FEATURED'
}

export enum AdSortByEnum {
  Date = 'DATE',
  Recommended = 'RECOMMENDED',
  SalaryAsc = 'SALARY_ASC',
  SalaryDesc = 'SALARY_DESC'
}

export type AdStateCounts = {
  __typename?: 'AdStateCounts';
  allCount: Scalars['Int']['output'];
  awaitingPaymentCount: Scalars['Int']['output'];
  expiredCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  publishedCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
};

export enum AdStatusEnum {
  /** Invalid */
  Invalid = 'INVALID',
  /** Not found */
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

/** Autogenerated input type of AdSwitchActivation */
export type AdSwitchActivationInput = {
  adType: AdTypeEnum;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdSwitchActivation. */
export type AdSwitchActivationPayload = {
  __typename?: 'AdSwitchActivationPayload';
  ad?: Maybe<Ad>;
  status: AdStatusEnum;
};

export enum AdTypeEnum {
  Resume = 'RESUME',
  Vacancy = 'VACANCY'
}

/** Autogenerated input type of AuthSendEmailOtpCode */
export type AuthSendEmailOtpCodeInput = {
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AuthSendEmailOtpCode. */
export type AuthSendEmailOtpCodePayload = {
  __typename?: 'AuthSendEmailOtpCodePayload';
  errors: Array<UserError>;
  lockExpiresAt?: Maybe<Scalars['String']['output']>;
  status: SimpleStatusEnum;
  usePassword?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AuthVerifyEmailOtpCode */
export type AuthVerifyEmailOtpCodeInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AuthVerifyEmailOtpCode. */
export type AuthVerifyEmailOtpCodePayload = {
  __typename?: 'AuthVerifyEmailOtpCodePayload';
  lockExpiresAt?: Maybe<Scalars['String']['output']>;
  persisted?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<Profile>;
  status: SignInStatusEnum;
};

export type BalanceHistory = {
  __typename?: 'BalanceHistory';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: PaymentStatusEnum;
  targetId: Scalars['ID']['output'];
  targetType: Scalars['String']['output'];
};

export type BaseCompany = {
  ads: Array<Vacancy>;
  contactEmails?: Maybe<Array<ContactEmail>>;
  contactName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeesCount?: Maybe<EmployeesCountEnum>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['AssetUrl']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidType?: Maybe<PaidTypeEnum>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  postpaidLimit?: Maybe<Scalars['Int']['output']>;
  publishedCount: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['ID']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  specializationId?: Maybe<Scalars['ID']['output']>;
  specializationName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum BaseStatusEnum {
  /** Invalid */
  Invalid = 'INVALID',
  /** Not found */
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type Bookmark = {
  __typename?: 'Bookmark';
  ad?: Maybe<Ad>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for Bookmark. */
export type BookmarkConnection = {
  __typename?: 'BookmarkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BookmarkEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bookmark>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BookmarkCreate */
export type BookmarkCreateInput = {
  adType: AdTypeEnum;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BookmarkCreate. */
export type BookmarkCreatePayload = {
  __typename?: 'BookmarkCreatePayload';
  bookmark?: Maybe<Bookmark>;
  status: BookmarkStatusEnum;
};

/** Autogenerated input type of BookmarkDelete */
export type BookmarkDeleteInput = {
  adType: AdTypeEnum;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BookmarkDelete. */
export type BookmarkDeletePayload = {
  __typename?: 'BookmarkDeletePayload';
  bookmark?: Maybe<Bookmark>;
  status: BookmarkStatusEnum;
};

/** An edge in a connection. */
export type BookmarkEdge = {
  __typename?: 'BookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Bookmark>;
};

export enum BookmarkStatusEnum {
  /** Invalid */
  Invalid = 'INVALID',
  /** Not found */
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type Candidate = {
  __typename?: 'Candidate';
  age?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  educationId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  experienceId?: Maybe<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<GenderEnum>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['AssetUrl']['output']>;
  name: Scalars['String']['output'];
  patronymic?: Maybe<Scalars['String']['output']>;
  phones: Array<Scalars['String']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
};

/** Autogenerated input type of CandidateFastSignUp */
export type CandidateFastSignUpInput = {
  dateOfBirth: Scalars['String']['input'];
  educationId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  gender: GenderEnum;
  patronymic: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['Upload']['input']>;
  regionId: Scalars['ID']['input'];
  surname: Scalars['String']['input'];
};

/** Autogenerated return type of CandidateFastSignUp. */
export type CandidateFastSignUpPayload = {
  __typename?: 'CandidateFastSignUpPayload';
  email: Scalars['String']['output'];
  errors: Array<UserError>;
  profile?: Maybe<Profile>;
  status: SimpleStatusEnum;
};

/** Autogenerated input type of CandidateMinimalSignUp */
export type CandidateMinimalSignUpInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

/** Autogenerated return type of CandidateMinimalSignUp. */
export type CandidateMinimalSignUpPayload = {
  __typename?: 'CandidateMinimalSignUpPayload';
  email: Scalars['String']['output'];
  errors: Array<UserError>;
  profile?: Maybe<Profile>;
  status: SimpleStatusEnum;
};

/** Autogenerated input type of CandidateUpdate */
export type CandidateUpdateInput = {
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  educationId?: InputMaybe<Scalars['ID']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CandidateUpdate. */
export type CandidateUpdatePayload = {
  __typename?: 'CandidateUpdatePayload';
  candidate?: Maybe<Candidate>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

export type Category = {
  __typename?: 'Category';
  children: Array<Category>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Category>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for Category. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Category>;
};

export type Company = BaseCompany & {
  __typename?: 'Company';
  ads: Array<Vacancy>;
  contactEmails?: Maybe<Array<ContactEmail>>;
  contactName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeesCount?: Maybe<EmployeesCountEnum>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['AssetUrl']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidType?: Maybe<PaidTypeEnum>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  postpaidLimit?: Maybe<Scalars['Int']['output']>;
  publishedCount: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['ID']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  specializationId?: Maybe<Scalars['ID']['output']>;
  specializationName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

/** Autogenerated input type of CompanyFastSignUp */
export type CompanyFastSignUpInput = {
  contact: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Autogenerated return type of CompanyFastSignUp. */
export type CompanyFastSignUpPayload = {
  __typename?: 'CompanyFastSignUpPayload';
  email: Scalars['String']['output'];
  errors: Array<UserError>;
  profile?: Maybe<Profile>;
  status: SimpleStatusEnum;
};

/** Autogenerated input type of CompanyUpdate */
export type CompanyUpdateInput = {
  country?: InputMaybe<CountryCodeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeesCount?: InputMaybe<EmployeesCountEnum>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  specializationId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CompanyUpdate. */
export type CompanyUpdatePayload = {
  __typename?: 'CompanyUpdatePayload';
  company?: Maybe<Company>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

export type ContactEmail = {
  __typename?: 'ContactEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  verified: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactEmailCreate */
export type ContactEmailCreateInput = {
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ContactEmailCreate. */
export type ContactEmailCreatePayload = {
  __typename?: 'ContactEmailCreatePayload';
  contactEmail?: Maybe<ContactEmail>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

/** Autogenerated input type of ContactEmailDelete */
export type ContactEmailDeleteInput = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactEmailDelete. */
export type ContactEmailDeletePayload = {
  __typename?: 'ContactEmailDeletePayload';
  contactEmail?: Maybe<ContactEmail>;
  status: SimpleStatusEnum;
};

/** Autogenerated input type of ContactEmailUpdate */
export type ContactEmailUpdateInput = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactEmailUpdate. */
export type ContactEmailUpdatePayload = {
  __typename?: 'ContactEmailUpdatePayload';
  contactEmail?: Maybe<ContactEmail>;
  errors: Array<UserError>;
  status: BaseStatusEnum;
};

/** Autogenerated input type of ContactEmailVerify */
export type ContactEmailVerifyInput = {
  verificationToken: Scalars['String']['input'];
};

/** Autogenerated return type of ContactEmailVerify. */
export type ContactEmailVerifyPayload = {
  __typename?: 'ContactEmailVerifyPayload';
  contactEmail?: Maybe<ContactEmail>;
  status: SimpleStatusEnum;
};

/** ISO 3166-1 alpha-2 country code */
export enum CountryCodeEnum {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Argentina */
  Ar = 'AR',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Congo, The Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** Ghana */
  Gh = 'GH',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** Guatemala */
  Gt = 'GT',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** India */
  In = 'IN',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Mauritania */
  Mr = 'MR',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** Niger */
  Ne = 'NE',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Slovenia */
  Si = 'SI',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Chad */
  Td = 'TD',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Türkiye */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

export type CountryOption = {
  __typename?: 'CountryOption';
  alpha2: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Education = {
  __typename?: 'Education';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Employee count ranges */
export enum EmployeesCountEnum {
  /** 1-10 */
  Range_1_10 = 'RANGE_1_10',
  /** 11-50 */
  Range_11_50 = 'RANGE_11_50',
  /** 51-200 */
  Range_51_200 = 'RANGE_51_200',
  /** 201-500 */
  Range_201_500 = 'RANGE_201_500',
  /** 501-1000 */
  Range_501_1000 = 'RANGE_501_1000',
  /** 1000+ */
  Range_1000Plus = 'RANGE_1000_PLUS'
}

export type Experience = {
  __typename?: 'Experience';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum GenderEnum {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  invoiceableId: Scalars['ID']['output'];
  invoiceableType: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** Autogenerated input type of InvoiceCreate */
export type InvoiceCreateInput = {
  id: Scalars['ID']['input'];
  paymentMethodId: PaymentMethodEnum;
  platform?: InputMaybe<MediumEnum>;
  targetId: Scalars['ID']['input'];
  targetType: AdTypeEnum;
  token: Scalars['String']['input'];
  yigimTemplateGroup?: InputMaybe<PaymentCreateYigimTemplateGroupEnum>;
};

/** Autogenerated return type of InvoiceCreate. */
export type InvoiceCreatePayload = {
  __typename?: 'InvoiceCreatePayload';
  paymentResult?: Maybe<PaymentResult>;
};

export type JobApplication = {
  __typename?: 'JobApplication';
  body?: Maybe<Scalars['String']['output']>;
  candidate: Candidate;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  resume?: Maybe<Resume>;
  resumeDisabled?: Maybe<Scalars['Boolean']['output']>;
  vacancy: Vacancy;
};

/** The connection type for JobApplication. */
export type JobApplicationConnection = {
  __typename?: 'JobApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobApplication>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of JobApplicationCreate */
export type JobApplicationCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fullName: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  resumeId?: InputMaybe<Scalars['ID']['input']>;
  vacancyId: Scalars['ID']['input'];
};

/** Autogenerated return type of JobApplicationCreate. */
export type JobApplicationCreatePayload = {
  __typename?: 'JobApplicationCreatePayload';
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

/** An edge in a connection. */
export type JobApplicationEdge = {
  __typename?: 'JobApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JobApplication>;
};

export enum MediumEnum {
  Api = 'API',
  App = 'APP',
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type Mutation = {
  __typename?: 'Mutation';
  createBookmark?: Maybe<BookmarkCreatePayload>;
  createContactEmail?: Maybe<ContactEmailCreatePayload>;
  createInvoice?: Maybe<InvoiceCreatePayload>;
  createJobApplication?: Maybe<JobApplicationCreatePayload>;
  createPayment?: Maybe<PaymentCreatePayload>;
  createResume?: Maybe<ResumeCreatePayload>;
  createVacancy?: Maybe<VacancyCreatePayload>;
  deleteAd?: Maybe<AdDeletePayload>;
  deleteBookmark?: Maybe<BookmarkDeletePayload>;
  deleteContactEmail?: Maybe<ContactEmailDeletePayload>;
  fastSignUpCandidate?: Maybe<CandidateFastSignUpPayload>;
  fastSignUpCompany?: Maybe<CompanyFastSignUpPayload>;
  freeActivateResume?: Maybe<ResumeFreeActivatePayload>;
  freeActivateVacancy?: Maybe<VacancyFreeActivatePayload>;
  minimalSignUpCandidate?: Maybe<CandidateMinimalSignUpPayload>;
  sendEmailOtpCode?: Maybe<AuthSendEmailOtpCodePayload>;
  sendResetPassword?: Maybe<ProfileSendResetPasswordPayload>;
  signIn?: Maybe<ProfileSignInPayload>;
  signOut?: Maybe<ProfileSignOutPayload>;
  signUp?: Maybe<ProfileSignUpPayload>;
  switchActivationAd?: Maybe<AdSwitchActivationPayload>;
  updateCandidate?: Maybe<CandidateUpdatePayload>;
  updateCompany?: Maybe<CompanyUpdatePayload>;
  updateContactEmail?: Maybe<ContactEmailUpdatePayload>;
  updatePassword?: Maybe<ProfileUpdatePasswordPayload>;
  updateTheme?: Maybe<ProfileUpdateThemePayload>;
  verifyContactEmail?: Maybe<ContactEmailVerifyPayload>;
  verifyEmailOtpCode?: Maybe<AuthVerifyEmailOtpCodePayload>;
};


export type MutationCreateBookmarkArgs = {
  input: BookmarkCreateInput;
};


export type MutationCreateContactEmailArgs = {
  input: ContactEmailCreateInput;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type MutationCreateJobApplicationArgs = {
  input: JobApplicationCreateInput;
};


export type MutationCreatePaymentArgs = {
  input: PaymentCreateInput;
};


export type MutationCreateResumeArgs = {
  input: ResumeCreateInput;
};


export type MutationCreateVacancyArgs = {
  input: VacancyCreateInput;
};


export type MutationDeleteAdArgs = {
  input: AdDeleteInput;
};


export type MutationDeleteBookmarkArgs = {
  input: BookmarkDeleteInput;
};


export type MutationDeleteContactEmailArgs = {
  input: ContactEmailDeleteInput;
};


export type MutationFastSignUpCandidateArgs = {
  input: CandidateFastSignUpInput;
};


export type MutationFastSignUpCompanyArgs = {
  input: CompanyFastSignUpInput;
};


export type MutationFreeActivateResumeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFreeActivateVacancyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMinimalSignUpCandidateArgs = {
  input: CandidateMinimalSignUpInput;
};


export type MutationSendEmailOtpCodeArgs = {
  input: AuthSendEmailOtpCodeInput;
};


export type MutationSendResetPasswordArgs = {
  input: ProfileSendResetPasswordInput;
};


export type MutationSignInArgs = {
  input: ProfileSignInInput;
};


export type MutationSignUpArgs = {
  input: ProfileSignUpInput;
};


export type MutationSwitchActivationAdArgs = {
  input: AdSwitchActivationInput;
};


export type MutationUpdateCandidateArgs = {
  input: CandidateUpdateInput;
};


export type MutationUpdateCompanyArgs = {
  input: CompanyUpdateInput;
};


export type MutationUpdateContactEmailArgs = {
  input: ContactEmailUpdateInput;
};


export type MutationUpdatePasswordArgs = {
  input: ProfileUpdatePasswordInput;
};


export type MutationUpdateThemeArgs = {
  theme: ProfileThemeEnum;
};


export type MutationVerifyContactEmailArgs = {
  input: ContactEmailVerifyInput;
};


export type MutationVerifyEmailOtpCodeArgs = {
  input: AuthVerifyEmailOtpCodeInput;
};

export type Page = {
  __typename?: 'Page';
  bodyMarkdown: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaidService = {
  __typename?: 'PaidService';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<PaidServiceOption>;
  /** Payment methods for current user */
  paymentMethods: Array<PaymentMethod>;
  /** Type of target (Resume, Vacancy, User) */
  targetType: PaidServiceTargetTypeEnum;
  title?: Maybe<Scalars['String']['output']>;
};

/** Paid service option such as duration, quantity, etc. */
export type PaidServiceOption = {
  __typename?: 'PaidServiceOption';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Initial price of paid service option. */
  price: Scalars['Float']['output'];
};

export enum PaidServiceTargetTypeEnum {
  Resume = 'RESUME',
  User = 'USER',
  Vacancy = 'VACANCY'
}

export enum PaidTypeEnum {
  Postpaid = 'postpaid',
  Prepaid = 'prepaid'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  finished?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  returnTo?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['ID']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  targetId?: Maybe<Scalars['ID']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of PaymentCreate */
export type PaymentCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  paidServiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodId: PaymentMethodEnum;
  platform?: InputMaybe<MediumEnum>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<AdTypeEnum>;
  yigimTemplateGroup?: InputMaybe<PaymentCreateYigimTemplateGroupEnum>;
};

/** Autogenerated return type of PaymentCreate. */
export type PaymentCreatePayload = {
  __typename?: 'PaymentCreatePayload';
  paymentResult?: Maybe<PaymentResult>;
};

export enum PaymentCreateStatusEnum {
  Failure = 'FAILURE',
  /** Follow to the URL provided */
  Redirect = 'REDIRECT',
  Success = 'SUCCESS'
}

/** Vendor template group. Must have "0001" and "0002" templates. */
export enum PaymentCreateYigimTemplateGroupEnum {
  Gpl = 'GPL',
  Tpl = 'TPL'
}

/** Method of payment by the user for a paid service */
export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** User balance that can be spent on the paid service */
  balance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isAppleGooglePayEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export enum PaymentMethodEnum {
  Azericard = 'azericard',
  Goldenpay = 'goldenpay',
  Kapitalbank = 'kapitalbank',
  Portmanat = 'portmanat',
  Wallet = 'wallet',
  Yigim = 'yigim'
}

export type PaymentResult = {
  __typename?: 'PaymentResult';
  errors: Array<UserError>;
  /** Payment date */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Payment index */
  paymentId?: Maybe<Scalars['ID']['output']>;
  /** If provided, follow the URL to continue payment */
  redirectUrl?: Maybe<Scalars['Url']['output']>;
  status: PaymentCreateStatusEnum;
  /** Payment target index */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Payment target type */
  targetType?: Maybe<AdTypeEnum>;
};

export enum PaymentStatusEnum {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

/** Abstraction of current authenticated user */
export type Profile = UserProfile;

export enum ProfileAdTabStatesEnum {
  All = 'ALL',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export enum ProfileEnum {
  Candidate = 'CANDIDATE',
  Company = 'COMPANY'
}

/** Autogenerated input type of ProfileSendResetPassword */
export type ProfileSendResetPasswordInput = {
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ProfileSendResetPassword. */
export type ProfileSendResetPasswordPayload = {
  __typename?: 'ProfileSendResetPasswordPayload';
  status: SendResetPasswordStatusEnum;
};

/** Autogenerated input type of ProfileSignIn */
export type ProfileSignInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of ProfileSignIn. */
export type ProfileSignInPayload = {
  __typename?: 'ProfileSignInPayload';
  lockExpiresAt?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  status: SignInStatusEnum;
};

/** Autogenerated return type of ProfileSignOut. */
export type ProfileSignOutPayload = {
  __typename?: 'ProfileSignOutPayload';
  status: SignOutStatusEnum;
};

/** Autogenerated input type of ProfileSignUp */
export type ProfileSignUpInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profile: ProfileEnum;
};

/** Autogenerated return type of ProfileSignUp. */
export type ProfileSignUpPayload = {
  __typename?: 'ProfileSignUpPayload';
  errors: Array<UserError>;
  profile?: Maybe<Profile>;
  status: SimpleStatusEnum;
};

export enum ProfileThemeEnum {
  Dark = 'dark',
  Light = 'light'
}

/** Autogenerated input type of ProfileUpdatePassword */
export type ProfileUpdatePasswordInput = {
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of ProfileUpdatePassword. */
export type ProfileUpdatePasswordPayload = {
  __typename?: 'ProfileUpdatePasswordPayload';
  status: UpdatePasswordStatusEnum;
};

/** Autogenerated return type of ProfileUpdateTheme. */
export type ProfileUpdateThemePayload = {
  __typename?: 'ProfileUpdateThemePayload';
  status: UpdateStatusEnum;
};

export type Query = {
  __typename?: 'Query';
  balanceHistory?: Maybe<Array<BalanceHistory>>;
  bookmarks: BookmarkConnection;
  categories: Array<Category>;
  company?: Maybe<Company>;
  /** List of countries by locale */
  countries: Array<CountryOption>;
  draftResume?: Maybe<Resume>;
  draftVacancy?: Maybe<Vacancy>;
  educations: Array<Education>;
  /** Embedded endpoint for vacancies */
  embedVacancies: VacancyConnection;
  experiences: Array<Experience>;
  jobApplications: JobApplicationConnection;
  page?: Maybe<Page>;
  pages: Array<Page>;
  paidServices: Array<PaidService>;
  payment?: Maybe<Payment>;
  profile?: Maybe<Profile>;
  regions: Array<Region>;
  resume?: Maybe<Resume>;
  resumes: ResumeConnection;
  searchCategories: CategoryConnection;
  searchCompanies: CompanyConnection;
  searchSuggestions: Array<SearchSuggestion>;
  seoMetadata?: Maybe<Seo>;
  sitemap: Array<Sitemap>;
  specializations: Array<Specialization>;
  statistic: Statistic;
  theme: ProfileThemeEnum;
  vacancies: VacancyConnection;
  vacancy?: Maybe<Vacancy>;
};


export type QueryBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmbedVacanciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<AdScopeEnum>;
  sortBy?: InputMaybe<AdSortByEnum>;
};


export type QueryJobApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  profile: ProfileEnum;
};


export type QueryPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPaidServicesArgs = {
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetType: PaidServiceTargetTypeEnum;
};


export type QueryPaymentArgs = {
  signedId: Scalars['String']['input'];
};


export type QueryResumeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResumesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<AdScopeEnum>;
  sortBy?: InputMaybe<AdSortByEnum>;
};


export type QuerySearchCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchSuggestionsArgs = {
  searchTerm: Scalars['String']['input'];
  targetType: AdTypeEnum;
};


export type QuerySeoMetadataArgs = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  adType: AdTypeEnum;
  filters?: InputMaybe<AdFilter>;
};


export type QueryStatisticArgs = {
  adType: AdTypeEnum;
};


export type QueryVacanciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<AdScopeEnum>;
  sortBy?: InputMaybe<AdSortByEnum>;
};


export type QueryVacancyArgs = {
  id: Scalars['ID']['input'];
};

export type Region = {
  __typename?: 'Region';
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Resume = AdBase & {
  __typename?: 'Resume';
  activatable?: Maybe<Scalars['Boolean']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  awaitingPayment?: Maybe<Scalars['Boolean']['output']>;
  bumpedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  daysLeft?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draft: Scalars['Boolean']['output'];
  education?: Maybe<Scalars['String']['output']>;
  educationId?: Maybe<Scalars['ID']['output']>;
  educationInfo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  experienceId?: Maybe<Scalars['ID']['output']>;
  experienceInfo?: Maybe<Scalars['String']['output']>;
  expirable?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnum>;
  hits?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Invoice>;
  isBookmarked: Scalars['Boolean']['output'];
  isBumped?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isMine: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidServices: Array<PaidService>;
  patronymic?: Maybe<Scalars['String']['output']>;
  personal?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  positionName?: Maybe<Scalars['String']['output']>;
  profile: Candidate;
  regionId?: Maybe<Scalars['ID']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  relatedAds?: Maybe<Array<Ad>>;
  salaryFrom?: Maybe<Scalars['Int']['output']>;
  salaryTo?: Maybe<Scalars['Int']['output']>;
  skills?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vipAds?: Maybe<Array<Ad>>;
};

/** The connection type for Resume. */
export type ResumeConnection = {
  __typename?: 'ResumeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResumeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Resume>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ResumeCreate */
export type ResumeCreateInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  educationId?: InputMaybe<Scalars['ID']['input']>;
  educationInfo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  experienceInfo?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  personal?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  salaryFrom?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResumeCreate. */
export type ResumeCreatePayload = {
  __typename?: 'ResumeCreatePayload';
  ad?: Maybe<Resume>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

/** An edge in a connection. */
export type ResumeEdge = {
  __typename?: 'ResumeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Resume>;
};

/** Autogenerated return type of ResumeFreeActivate. */
export type ResumeFreeActivatePayload = {
  __typename?: 'ResumeFreeActivatePayload';
  ad?: Maybe<Resume>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  id: Scalars['ID']['output'];
  searchTerm: Scalars['String']['output'];
};

export enum SendResetPasswordStatusEnum {
  /** Limit exceeded */
  LimitExceeded = 'LIMIT_EXCEEDED',
  Success = 'SUCCESS'
}

export type Seo = {
  __typename?: 'Seo';
  breadcrumbs: Array<SeoBreadcrumbsItem>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SeoBreadcrumbsItem = {
  __typename?: 'SeoBreadcrumbsItem';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum SignInStatusEnum {
  /** Email in ban */
  Banned = 'BANNED',
  /** Invalid credentials */
  InvalidCredentials = 'INVALID_CREDENTIALS',
  /** Limit exceeded */
  LimitExceeded = 'LIMIT_EXCEEDED',
  Success = 'SUCCESS'
}

export enum SignOutStatusEnum {
  Success = 'SUCCESS'
}

export enum SimpleStatusEnum {
  Invalid = 'INVALID',
  Success = 'SUCCESS'
}

export type Sitemap = {
  __typename?: 'Sitemap';
  name: Scalars['String']['output'];
  records: Array<SitemapElement>;
};

export type SitemapElement = {
  __typename?: 'SitemapElement';
  id: Scalars['ID']['output'];
  lastmod: Scalars['ISO8601DateTime']['output'];
};

export type Specialization = {
  __typename?: 'Specialization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Statistic = {
  __typename?: 'Statistic';
  month: Scalars['Int']['output'];
  week: Scalars['Int']['output'];
};

export enum UpdatePasswordStatusEnum {
  /** Invalid */
  Invalid = 'INVALID',
  /** Invalid token */
  InvalidToken = 'INVALID_TOKEN',
  Success = 'SUCCESS'
}

export enum UpdateStatusEnum {
  Invalid = 'INVALID',
  Success = 'SUCCESS'
}

/** A readable user/business-level error */
export type UserError = {
  __typename?: 'UserError';
  /** Corresponding error code */
  code?: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Scalars['String']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  ads: AdConnection;
  adsStateCounts: AdStateCounts;
  candidate?: Maybe<Candidate>;
  company?: Maybe<Company>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  theme: ProfileThemeEnum;
  walletBalance?: Maybe<Scalars['Float']['output']>;
};


export type UserProfileAdsArgs = {
  adType?: InputMaybe<AdTypeEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<ProfileAdTabStatesEnum>;
};


export type UserProfileAdsStateCountsArgs = {
  adType?: InputMaybe<AdTypeEnum>;
};

export type Vacancy = AdBase & {
  __typename?: 'Vacancy';
  activatable?: Maybe<Scalars['Boolean']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  awaitingPayment?: Maybe<Scalars['Boolean']['output']>;
  bumpedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  daysLeft?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draft: Scalars['Boolean']['output'];
  education?: Maybe<Scalars['String']['output']>;
  educationId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  experienceId?: Maybe<Scalars['ID']['output']>;
  expirable?: Maybe<Scalars['Boolean']['output']>;
  hits?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Invoice>;
  isAppliedJob?: Maybe<Scalars['Boolean']['output']>;
  isBookmarked: Scalars['Boolean']['output'];
  isBumped?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isMine: Scalars['Boolean']['output'];
  jobDescription?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidServices: Array<PaidService>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  positionName?: Maybe<Scalars['String']['output']>;
  profile: Company;
  regionId?: Maybe<Scalars['ID']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  relatedAds?: Maybe<Array<Ad>>;
  requirements?: Maybe<Scalars['String']['output']>;
  responsibilities?: Maybe<Scalars['String']['output']>;
  salaryFrom?: Maybe<Scalars['Int']['output']>;
  salaryTo?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vipAds?: Maybe<Array<Ad>>;
};

/** The connection type for Vacancy. */
export type VacancyConnection = {
  __typename?: 'VacancyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VacancyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Vacancy>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of VacancyCreate */
export type VacancyCreateInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  educationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  salaryFrom?: InputMaybe<Scalars['Int']['input']>;
  salaryTo?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of VacancyCreate. */
export type VacancyCreatePayload = {
  __typename?: 'VacancyCreatePayload';
  ad?: Maybe<Vacancy>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

/** An edge in a connection. */
export type VacancyEdge = {
  __typename?: 'VacancyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Vacancy>;
};

/** Autogenerated return type of VacancyFreeActivate. */
export type VacancyFreeActivatePayload = {
  __typename?: 'VacancyFreeActivatePayload';
  ad?: Maybe<Vacancy>;
  errors: Array<UserError>;
  status: SimpleStatusEnum;
};

export type DeleteAdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type DeleteAdMutation = { __typename?: 'Mutation', deleteAd?: { __typename?: 'AdDeletePayload', status: AdStatusEnum } | null };

export type SwitchActivateAdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type SwitchActivateAdMutation = { __typename?: 'Mutation', switchActivationAd?: { __typename?: 'AdSwitchActivationPayload', status: AdStatusEnum, ad?:
      | { __typename: 'Resume', id?: string | null, activatable?: boolean | null }
      | { __typename: 'Vacancy', id?: string | null, activatable?: boolean | null }
     | null } | null };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'ProfileSignInPayload', status: SignInStatusEnum, lockExpiresAt?: string | null, profile?: { __typename?: 'UserProfile', email: string, id: string, company?: { __typename?: 'Company', id: string } | null, candidate?: { __typename?: 'Candidate', id: string } | null } | null } | null };

export type SendEmailOtpCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendEmailOtpCodeMutation = { __typename?: 'Mutation', sendEmailOtpCode?: { __typename?: 'AuthSendEmailOtpCodePayload', status: SimpleStatusEnum, usePassword?: boolean | null, lockExpiresAt?: string | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type VerifyEmailOtpCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyEmailOtpCodeMutation = { __typename?: 'Mutation', verifyEmailOtpCode?: { __typename?: 'AuthVerifyEmailOtpCodePayload', status: SignInStatusEnum, persisted?: boolean | null, lockExpiresAt?: string | null, profile?: { __typename?: 'UserProfile', email: string, id: string, company?: { __typename?: 'Company', id: string } | null, candidate?: { __typename?: 'Candidate', id: string } | null } | null } | null };

export type SignUpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profile: ProfileEnum;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp?: { __typename?: 'ProfileSignUpPayload', status: SimpleStatusEnum, profile?: { __typename?: 'UserProfile', email: string, id: string } | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type SendResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendResetPasswordMutation = { __typename?: 'Mutation', sendResetPassword?: { __typename?: 'ProfileSendResetPasswordPayload', status: SendResetPasswordStatusEnum } | null };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOut?: { __typename?: 'ProfileSignOutPayload', status: SignOutStatusEnum } | null };

export type FastSignUpCompanyMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  contact: Scalars['String']['input'];
}>;


export type FastSignUpCompanyMutation = { __typename?: 'Mutation', fastSignUpCompany?: { __typename?: 'CompanyFastSignUpPayload', email: string, status: SimpleStatusEnum, profile?: { __typename?: 'UserProfile', email: string, id: string } | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type FastSignUpCandidateMutationVariables = Exact<{
  input: CandidateFastSignUpInput;
}>;


export type FastSignUpCandidateMutation = { __typename?: 'Mutation', fastSignUpCandidate?: { __typename?: 'CandidateFastSignUpPayload', email: string, status: SimpleStatusEnum, profile?: { __typename?: 'UserProfile', email: string, id: string } | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type MinimalSignUpCandidateMutationVariables = Exact<{
  input: CandidateMinimalSignUpInput;
}>;


export type MinimalSignUpCandidateMutation = { __typename?: 'Mutation', minimalSignUpCandidate?: { __typename?: 'CandidateMinimalSignUpPayload', email: string, status: SimpleStatusEnum, profile?: { __typename?: 'UserProfile', email: string, id: string } | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type CreateBookmarkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  adType: AdTypeEnum;
}>;


export type CreateBookmarkMutation = { __typename?: 'Mutation', createBookmark?: { __typename?: 'BookmarkCreatePayload', status: BookmarkStatusEnum, bookmark?: { __typename?: 'Bookmark', id?: string | null } | null } | null };

export type DeleteBookmarkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  adType: AdTypeEnum;
}>;


export type DeleteBookmarkMutation = { __typename?: 'Mutation', deleteBookmark?: { __typename?: 'BookmarkDeletePayload', status: BookmarkStatusEnum } | null };

export type CreateJobApplicationMutationVariables = Exact<{
  vacancyId: Scalars['ID']['input'];
  fullName: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  resumeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateJobApplicationMutation = { __typename?: 'Mutation', createJobApplication?: { __typename?: 'JobApplicationCreatePayload', status: SimpleStatusEnum, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type CreatePaymentMutationVariables = Exact<{
  paidServiceId: Scalars['ID']['input'];
  paymentMethodId: PaymentMethodEnum;
  platform?: InputMaybe<MediumEnum>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<AdTypeEnum>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  yigimTemplateGroup?: InputMaybe<PaymentCreateYigimTemplateGroupEnum>;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'PaymentCreatePayload', paymentResult?: { __typename?: 'PaymentResult', paymentDate?: any | null, paymentId?: string | null, redirectUrl?: any | null, status: PaymentCreateStatusEnum, targetId?: string | null, targetType?: AdTypeEnum | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null } | null };

export type CreateResumeMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  educationId?: InputMaybe<Scalars['ID']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  personal?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  salaryFrom?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  educationInfo?: InputMaybe<Scalars['String']['input']>;
  experienceInfo?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateResumeMutation = { __typename?: 'Mutation', createResume?: { __typename?: 'ResumeCreatePayload', status: SimpleStatusEnum, ad?: { __typename?: 'Resume', approvedAt?: any | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, draft: boolean, education?: string | null, educationId?: string | null, educationInfo?: string | null, experience?: string | null, experienceId?: string | null, experienceInfo?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null, awaitingPayment?: boolean | null, dateOfBirth?: any | null, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type FreeActivateResumeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FreeActivateResumeMutation = { __typename?: 'Mutation', freeActivateResume?: { __typename?: 'ResumeFreeActivatePayload', status: SimpleStatusEnum, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type DeleteAdResumeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type DeleteAdResumeMutation = { __typename?: 'Mutation', deleteAd?: { __typename?: 'AdDeletePayload', status: AdStatusEnum } | null };

export type CreateBookmarkResumeMutationVariables = Exact<{
  adId: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type CreateBookmarkResumeMutation = { __typename?: 'Mutation', createBookmark?: { __typename?: 'BookmarkCreatePayload', status: BookmarkStatusEnum } | null };

export type DeleteBookmarkResumeMutationVariables = Exact<{
  adId: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type DeleteBookmarkResumeMutation = { __typename?: 'Mutation', deleteBookmark?: { __typename?: 'BookmarkDeletePayload', status: BookmarkStatusEnum } | null };

export type CreateVacancyMutationVariables = Exact<{
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  educationId?: InputMaybe<Scalars['ID']['input']>;
  experienceId?: InputMaybe<Scalars['ID']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  salaryFrom?: InputMaybe<Scalars['Int']['input']>;
  salaryTo?: InputMaybe<Scalars['Int']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVacancyMutation = { __typename?: 'Mutation', createVacancy?: { __typename?: 'VacancyCreatePayload', status: SimpleStatusEnum, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }>, ad?: { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, approvedAt?: any | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, contactName?: string | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, education?: string | null, educationId?: string | null, experience?: string | null, experienceId?: string | null, expirable?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, id?: string | null, phones?: Array<string> | null, email?: string | null } | null } | null };

export type CreateBookmarkVacancyMutationVariables = Exact<{
  adId: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type CreateBookmarkVacancyMutation = { __typename?: 'Mutation', createBookmark?: { __typename?: 'BookmarkCreatePayload', status: BookmarkStatusEnum } | null };

export type DeleteBookmarkVacancyMutationVariables = Exact<{
  adId: Scalars['ID']['input'];
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type DeleteBookmarkVacancyMutation = { __typename?: 'Mutation', deleteBookmark?: { __typename?: 'BookmarkDeletePayload', status: BookmarkStatusEnum } | null };

export type FreeActivateVacancyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FreeActivateVacancyMutation = { __typename?: 'Mutation', freeActivateVacancy?: { __typename?: 'VacancyFreeActivatePayload', status: SimpleStatusEnum, errors: Array<{ __typename?: 'UserError', code?: string | null, message: string, path?: string | null }> } | null };

export type AdsQueryVariables = Exact<{
  state: ProfileAdTabStatesEnum;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type AdsQuery = { __typename?: 'Query', profile?: { __typename?: 'UserProfile', ads: { __typename?: 'AdConnection', nodes?: Array<
        | { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
        | { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
       | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export type VacanciesQueryVariables = Exact<{
  filter?: InputMaybe<AdFilter>;
  scope?: InputMaybe<AdScopeEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AdSortByEnum>;
}>;


export type VacanciesQuery = { __typename?: 'Query', vacancies: { __typename?: 'VacancyConnection', totalCount: number, edges?: Array<{ __typename?: 'VacancyEdge', cursor: string } | null> | null, nodes?: Array<{ __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ResumesQueryVariables = Exact<{
  filter?: InputMaybe<AdFilter>;
  scope?: InputMaybe<AdScopeEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AdSortByEnum>;
}>;


export type ResumesQuery = { __typename?: 'Query', resumes: { __typename?: 'ResumeConnection', totalCount: number, edges?: Array<{ __typename?: 'ResumeEdge', cursor: string, node?: { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null } | null> | null, nodes?: Array<{ __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type BookmarksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BookmarksQuery = { __typename?: 'Query', bookmarks: { __typename?: 'BookmarkConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges?: Array<{ __typename?: 'BookmarkEdge', cursor: string } | null> | null, nodes?: Array<{ __typename?: 'Bookmark', id?: string | null, ad?:
        | { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
        | { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
       | null } | null> | null } };

export type CategoriesQueryVariables = Exact<{
  includeChildren?: Scalars['Boolean']['input'];
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, parentId?: number | null, children?: Array<{ __typename?: 'Category', id: string, name: string, parentId?: number | null }> }> };

export type CompanyNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyNameQuery = { __typename?: 'Query', company?: { __typename?: 'Company', name?: string | null } | null };

export type CompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', publishedCount: number, regionId?: string | null, regionName?: string | null, specializationName?: string | null, contactName?: string | null, email?: string | null, id: string, logoUrl?: any | null, name?: string | null, phones?: Array<string> | null, description?: string | null, ads: Array<{ __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }> } | null };

export type EmptyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EmptyQueryQuery = { __typename: 'Query' };

export type PaidServiceOptionFieldsFragment = { __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number };

export type PaidServicePaymentMethodsFieldsFragment = { __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null };

export type PaidServiceFieldsFragment = { __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> };

export type VacancyCardFieldsFragment = { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> };

export type VacancyFieldsFragment = { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, contactName?: string | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, education?: string | null, educationId?: string | null, experience?: string | null, experienceId?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isAppliedJob?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, link?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> };

export type ResumeCardFieldsFragment = { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> };

export type ResumeFieldsFragment = { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, education?: string | null, educationId?: string | null, educationInfo?: string | null, experience?: string | null, experienceId?: string | null, experienceInfo?: string | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }>, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null };

export type AdsStateCountsFragment = { __typename?: 'AdStateCounts', allCount: number, publishedCount: number, expiredCount: number, pendingCount: number, rejectedCount: number, awaitingPaymentCount: number };

export type CompanyFieldsFragment = { __typename?: 'Company', contactName?: string | null, email?: string | null, id: string, logoUrl?: any | null, name?: string | null, phones?: Array<string> | null, description?: string | null };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null };

export type PagesQueryVariables = Exact<{ [key: string]: never; }>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', slug: string, title: string, id: string }> };

export type PageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', bodyMarkdown: string, id: string, slug: string, title: string } | null };

export type PaidServicesQueryVariables = Exact<{
  targetType: PaidServiceTargetTypeEnum;
  targetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PaidServicesQuery = { __typename?: 'Query', paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> };

export type GetPaymentQueryVariables = Exact<{
  signedId: Scalars['String']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: string, amount: number, targetId?: string | null, targetType?: string | null, message?: string | null, success?: boolean | null, finished?: boolean | null, serviceName?: string | null, serviceId?: string | null, updatedAt?: any | null, returnTo?: string | null, source?: string | null } | null };

export type ProfileFullQueryVariables = Exact<{
  state?: InputMaybe<ProfileAdTabStatesEnum>;
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type ProfileFullQuery = { __typename?: 'Query', profile?: { __typename?: 'UserProfile', id: string, email: string, walletBalance?: number | null, adsStateCounts: { __typename?: 'AdStateCounts', allCount: number, publishedCount: number, expiredCount: number, pendingCount: number, rejectedCount: number, awaitingPaymentCount: number }, company?: { __typename?: 'Company', contactName?: string | null, email?: string | null, id: string, logoUrl?: any | null, name?: string | null, phones?: Array<string> | null, description?: string | null } | null, ads: { __typename?: 'AdConnection', nodes?: Array<
        | { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
        | { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> }
       | null> | null }, candidate?: { __typename: 'Candidate', id: string, firstName: string, surname: string, patronymic?: string | null, name: string, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, email: string, phones: Array<string>, regionId?: string | null, educationId?: string | null, experienceId?: string | null, logoUrl?: any | null } | null } | null };

export type ProfileMinQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileMinQuery = { __typename?: 'Query', profile?: { __typename?: 'UserProfile', id: string, email: string, walletBalance?: number | null, company?: { __typename?: 'Company', id: string, logoUrl?: any | null, name?: string | null, phones?: Array<string> | null, email?: string | null, paidType?: PaidTypeEnum | null, postpaidLimit?: number | null } | null, candidate?: { __typename?: 'Candidate', id: string, firstName: string, surname: string, logoUrl?: any | null, email: string, phones: Array<string>, patronymic?: string | null, gender?: GenderEnum | null, dateOfBirth?: any | null, regionId?: string | null, regionName?: string | null } | null } | null };

export type AdsStateCountsQueryVariables = Exact<{
  adType?: InputMaybe<AdTypeEnum>;
}>;


export type AdsStateCountsQuery = { __typename?: 'Query', profile?: { __typename?: 'UserProfile', adsStateCounts: { __typename?: 'AdStateCounts', allCount: number, publishedCount: number, expiredCount: number, pendingCount: number, rejectedCount: number, awaitingPaymentCount: number } } | null };

export type ResumeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumeQuery = { __typename?: 'Query', resume?: { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, education?: string | null, educationId?: string | null, educationInfo?: string | null, experience?: string | null, experienceId?: string | null, experienceInfo?: string | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }>, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null } | null };

export type BaseResumeFieldsFragment = { __typename?: 'Resume', approvedAt?: any | null, activatable?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, education?: string | null, educationInfo?: string | null, experience?: string | null, experienceInfo?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, relatedAds?: Array<
    | { __typename?: 'Resume', approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null }
    | { __typename?: 'Vacancy' }
  > | null, profile: { __typename?: 'Candidate', age?: number | null, firstName: string, gender?: GenderEnum | null, id: string, logoUrl?: any | null, name: string, patronymic?: string | null, surname: string }, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null };

export type GetFeaturedResumesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedResumesQuery = { __typename?: 'Query', resumes: { __typename?: 'ResumeConnection', edges?: Array<{ __typename?: 'ResumeEdge', node?: { __typename: 'Resume', activatable?: boolean | null, id?: string | null, draft: boolean, status?: string | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, daysLeft?: number | null, expirable?: boolean | null, deletable?: boolean | null, isMine: boolean, isBookmarked: boolean, hits?: number | null, positionName?: string | null, name?: string | null, description?: string | null, personal?: string | null, skills?: string | null, salaryFrom?: number | null, salaryTo?: number | null, firstName?: string | null, surname?: string | null, patronymic?: string | null, email?: string | null, phones?: Array<string> | null, gender?: GenderEnum | null, age?: number | null, dateOfBirth?: any | null, regionId?: string | null, location?: string | null, categoryId?: string | null, logo?: string | null, rejectReason?: string | null, isBumped?: boolean | null, isFeatured?: boolean | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null } | null> | null } };

export type GetResumeQueryVariables = Exact<{
  resumeId: Scalars['ID']['input'];
}>;


export type GetResumeQuery = { __typename?: 'Query', resume?: { __typename?: 'Resume', approvedAt?: any | null, activatable?: boolean | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, education?: string | null, educationInfo?: string | null, experience?: string | null, experienceInfo?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, relatedAds?: Array<
      | { __typename?: 'Resume', approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null, activatable?: boolean | null, description?: string | null, education?: string | null, educationInfo?: string | null, experience?: string | null, experienceInfo?: string | null, email?: string | null, phones?: Array<string> | null, relatedAds?: Array<
          | { __typename?: 'Resume', approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, location?: string | null, logo?: string | null, name?: string | null, personal?: string | null, positionName?: string | null, rejectReason?: string | null, salaryFrom?: number | null, salaryTo?: number | null, skills?: string | null, status?: string | null, updatedAt?: any | null }
          | { __typename?: 'Vacancy' }
        > | null, profile: { __typename?: 'Candidate', age?: number | null, firstName: string, gender?: GenderEnum | null, id: string, logoUrl?: any | null, name: string, patronymic?: string | null, surname: string }, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null }
      | { __typename?: 'Vacancy' }
    > | null, profile: { __typename?: 'Candidate', age?: number | null, firstName: string, gender?: GenderEnum | null, id: string, logoUrl?: any | null, name: string, patronymic?: string | null, surname: string }, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null } | null };

export type EducationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EducationsQuery = { __typename?: 'Query', educations: Array<{ __typename?: 'Education', id: string, name: string }> };

export type ExperiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperiencesQuery = { __typename?: 'Query', experiences: Array<{ __typename?: 'Experience', id: string, name: string }> };

export type RegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', default: boolean, id: string, name: string }> };

export type StatisticQueryVariables = Exact<{
  adType: AdTypeEnum;
}>;


export type StatisticQuery = { __typename?: 'Query', statistic: { __typename?: 'Statistic', month: number, week: number } };

export type SearchSuggestionsQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  targetType: AdTypeEnum;
}>;


export type SearchSuggestionsQuery = { __typename?: 'Query', searchSuggestions: Array<{ __typename?: 'SearchSuggestion', id: string, searchTerm: string }> };

export type SeoMetadataQueryVariables = Exact<{
  adId?: InputMaybe<Scalars['ID']['input']>;
  adType: AdTypeEnum;
  filters?: InputMaybe<AdFilter>;
}>;


export type SeoMetadataQuery = { __typename?: 'Query', seoMetadata?: { __typename?: 'Seo', title?: string | null, description?: string | null, breadcrumbs: Array<{ __typename?: 'SeoBreadcrumbsItem', id?: string | null, name: string, position: number, type: string }> } | null };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, parentId?: number | null, children: Array<{ __typename?: 'Category', id: string, name: string, parentId?: number | null }> }> };

export type RegionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQueryQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, default: boolean }> };

export type SitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapQuery = { __typename?: 'Query', sitemap: Array<{ __typename?: 'Sitemap', name: string, records: Array<{ __typename?: 'SitemapElement', id: string, lastmod: any }> }> };

export type DraftVacancyQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftVacancyQuery = { __typename?: 'Query', draftVacancy?: { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, contactName?: string | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, education?: string | null, educationId?: string | null, experience?: string | null, experienceId?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isAppliedJob?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, link?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null };

export type VacancyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VacancyQuery = { __typename?: 'Query', vacancy?: { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, contactName?: string | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, education?: string | null, educationId?: string | null, experience?: string | null, experienceId?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isAppliedJob?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, link?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null };

export type BaseVacancyFieldsFragment = { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, activatable?: boolean | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, education?: string | null, experience?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isAppliedJob?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, link?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, email?: string | null, phones?: Array<string> | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, responsibilities?: string | null, contactName?: string | null, relatedAds?: Array<
    | { __typename?: 'Resume' }
    | { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, profile: { __typename?: 'Company', logoUrl?: any | null, name?: string | null } }
  > | null, vipAds?: Array<
    | { __typename?: 'Resume' }
    | { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, profile: { __typename?: 'Company', logoUrl?: any | null, name?: string | null } }
  > | null, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null, profile: { __typename?: 'Company', contactName?: string | null, description?: string | null, id: string, logoUrl?: any | null, name?: string | null, publishedCount: number, regionName?: string | null, specializationName?: string | null } };

export type GetVacancyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVacancyQuery = { __typename?: 'Query', vacancy?: { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, activatable?: boolean | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, education?: string | null, experience?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isAppliedJob?: boolean | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, link?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, email?: string | null, phones?: Array<string> | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, responsibilities?: string | null, contactName?: string | null, relatedAds?: Array<
      | { __typename?: 'Resume' }
      | { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, profile: { __typename?: 'Company', logoUrl?: any | null, name?: string | null } }
    > | null, vipAds?: Array<
      | { __typename?: 'Resume' }
      | { __typename?: 'Vacancy', ageFrom?: number | null, ageTo?: number | null, approvedAt?: any | null, bumpedAt?: any | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, rejectReason?: string | null, requirements?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, profile: { __typename?: 'Company', logoUrl?: any | null, name?: string | null } }
    > | null, category?: { __typename?: 'Category', id: string, name: string, parentId?: number | null } | null, profile: { __typename?: 'Company', contactName?: string | null, description?: string | null, id: string, logoUrl?: any | null, name?: string | null, publishedCount: number, regionName?: string | null, specializationName?: string | null } } | null };

export type GetFeaturedVacanciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedVacanciesQuery = { __typename?: 'Query', vacancies: { __typename?: 'VacancyConnection', edges?: Array<{ __typename?: 'VacancyEdge', node?: { __typename: 'Vacancy', activatable?: boolean | null, ageFrom?: number | null, ageTo?: number | null, awaitingPayment?: boolean | null, bumpedAt?: any | null, categoryId?: string | null, createdAt?: any | null, daysLeft?: number | null, deletable?: boolean | null, description?: string | null, draft: boolean, expirable?: boolean | null, hits?: number | null, id?: string | null, isBookmarked: boolean, isBumped?: boolean | null, isFeatured?: boolean | null, isMine: boolean, jobDescription?: string | null, location?: string | null, logo?: string | null, name?: string | null, positionName?: string | null, regionId?: string | null, rejectReason?: string | null, requirements?: string | null, responsibilities?: string | null, salaryFrom?: number | null, salaryTo?: number | null, status?: string | null, updatedAt?: any | null, email?: string | null, phones?: Array<string> | null, paidServices: Array<{ __typename?: 'PaidService', description?: string | null, id: string, targetType: PaidServiceTargetTypeEnum, title?: string | null, options: Array<{ __typename?: 'PaidServiceOption', description?: string | null, discount?: string | null, id: string, name: string, price: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethod', balance?: number | null, id: string, name: string, isAppleGooglePayEnabled?: boolean | null }> }> } | null } | null> | null } };

export const PaidServiceOptionFieldsFragmentDoc = gql`
    fragment PaidServiceOptionFields on PaidServiceOption {
  description
  discount
  id
  name
  price
}
    `;
export const PaidServicePaymentMethodsFieldsFragmentDoc = gql`
    fragment PaidServicePaymentMethodsFields on PaymentMethod {
  balance
  id
  name
  isAppleGooglePayEnabled
}
    `;
export const PaidServiceFieldsFragmentDoc = gql`
    fragment PaidServiceFields on PaidService {
  description
  id
  options {
    ...PaidServiceOptionFields
  }
  paymentMethods {
    ...PaidServicePaymentMethodsFields
  }
  targetType
  title
}
    ${PaidServiceOptionFieldsFragmentDoc}
${PaidServicePaymentMethodsFieldsFragmentDoc}`;
export const VacancyCardFieldsFragmentDoc = gql`
    fragment vacancyCardFields on Vacancy {
  activatable
  ageFrom
  ageTo
  awaitingPayment
  bumpedAt
  categoryId
  createdAt
  daysLeft
  deletable
  description
  draft
  expirable
  hits
  id
  isBookmarked
  isBumped
  isFeatured
  isMine
  jobDescription
  location
  logo
  name
  paidServices {
    ...PaidServiceFields
  }
  positionName
  regionId
  rejectReason
  requirements
  responsibilities
  salaryFrom
  salaryTo
  status
  updatedAt
  email
  phones
  __typename
}
    ${PaidServiceFieldsFragmentDoc}`;
export const VacancyFieldsFragmentDoc = gql`
    fragment vacancyFields on Vacancy {
  activatable
  ageFrom
  ageTo
  awaitingPayment
  bumpedAt
  categoryId
  createdAt
  contactName
  daysLeft
  deletable
  description
  draft
  education
  educationId
  experience
  experienceId
  expirable
  hits
  id
  isAppliedJob
  isBookmarked
  isBumped
  isFeatured
  isMine
  jobDescription
  link
  location
  logo
  name
  paidServices {
    ...PaidServiceFields
  }
  positionName
  regionId
  rejectReason
  requirements
  responsibilities
  salaryFrom
  salaryTo
  status
  updatedAt
  email
  phones
  __typename
}
    ${PaidServiceFieldsFragmentDoc}`;
export const ResumeCardFieldsFragmentDoc = gql`
    fragment resumeCardFields on Resume {
  activatable
  id
  draft
  status
  awaitingPayment
  bumpedAt
  createdAt
  updatedAt
  daysLeft
  expirable
  deletable
  isMine
  isBookmarked
  hits
  positionName
  name
  paidServices {
    ...PaidServiceFields
  }
  description
  personal
  skills
  salaryFrom
  salaryTo
  __typename
  firstName
  surname
  patronymic
  email
  phones
  gender
  age
  dateOfBirth
  regionId
  location
  categoryId
  logo
  rejectReason
  isBumped
  isFeatured
}
    ${PaidServiceFieldsFragmentDoc}`;
export const ResumeFieldsFragmentDoc = gql`
    fragment resumeFields on Resume {
  activatable
  id
  draft
  status
  awaitingPayment
  bumpedAt
  createdAt
  updatedAt
  daysLeft
  expirable
  deletable
  isMine
  isBookmarked
  hits
  positionName
  name
  paidServices {
    ...PaidServiceFields
  }
  description
  personal
  skills
  salaryFrom
  salaryTo
  __typename
  firstName
  surname
  patronymic
  email
  phones
  gender
  age
  dateOfBirth
  education
  educationId
  educationInfo
  experience
  experienceId
  experienceInfo
  regionId
  location
  categoryId
  category {
    id
    name
    parentId
  }
  logo
  rejectReason
  isBumped
  isFeatured
}
    ${PaidServiceFieldsFragmentDoc}`;
export const AdsStateCountsFragmentDoc = gql`
    fragment adsStateCounts on AdStateCounts {
  allCount
  publishedCount
  expiredCount
  pendingCount
  rejectedCount
  awaitingPaymentCount
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment companyFields on Company {
  contactName
  email
  id
  logoUrl
  name
  phones
  description
}
    `;
export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `;
export const BaseResumeFieldsFragmentDoc = gql`
    fragment BaseResumeFields on Resume {
  approvedAt
  activatable
  bumpedAt
  createdAt
  daysLeft
  deletable
  description
  education
  educationInfo
  experience
  experienceInfo
  expirable
  hits
  id
  isBookmarked
  isBumped
  isFeatured
  isMine
  location
  logo
  name
  personal
  positionName
  rejectReason
  relatedAds {
    ... on Resume {
      approvedAt
      bumpedAt
      createdAt
      daysLeft
      deletable
      expirable
      hits
      id
      isBookmarked
      isBumped
      isFeatured
      isMine
      location
      logo
      name
      personal
      positionName
      rejectReason
      salaryFrom
      salaryTo
      skills
      status
      updatedAt
    }
  }
  salaryFrom
  salaryTo
  skills
  status
  updatedAt
  email
  phones
  profile {
    age
    firstName
    gender
    id
    logoUrl
    name
    patronymic
    surname
  }
  category {
    id
    name
    parentId
  }
}
    `;
export const BaseVacancyFieldsFragmentDoc = gql`
    fragment BaseVacancyFields on Vacancy {
  ageFrom
  ageTo
  activatable
  approvedAt
  bumpedAt
  createdAt
  daysLeft
  deletable
  description
  education
  experience
  expirable
  hits
  id
  isAppliedJob
  isBookmarked
  isBumped
  isFeatured
  isMine
  jobDescription
  link
  location
  logo
  name
  positionName
  rejectReason
  email
  phones
  relatedAds {
    ... on Vacancy {
      ageFrom
      ageTo
      approvedAt
      bumpedAt
      createdAt
      daysLeft
      deletable
      description
      expirable
      hits
      id
      isBookmarked
      isBumped
      isFeatured
      isMine
      jobDescription
      location
      logo
      name
      positionName
      rejectReason
      requirements
      salaryFrom
      salaryTo
      status
      updatedAt
      profile {
        logoUrl
        name
      }
    }
  }
  requirements
  salaryFrom
  salaryTo
  status
  updatedAt
  vipAds {
    ... on Vacancy {
      ageFrom
      ageTo
      approvedAt
      bumpedAt
      createdAt
      daysLeft
      deletable
      description
      expirable
      hits
      id
      isBookmarked
      isBumped
      isFeatured
      isMine
      jobDescription
      location
      logo
      name
      positionName
      rejectReason
      requirements
      salaryFrom
      salaryTo
      status
      updatedAt
      profile {
        logoUrl
        name
      }
    }
  }
  responsibilities
  contactName
  category {
    id
    name
    parentId
  }
  profile {
    contactName
    description
    id
    logoUrl
    name
    publishedCount
    regionName
    specializationName
  }
}
    `;
export const DeleteAdDocument = gql`
    mutation DeleteAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
  deleteAd(input: {id: $id, adType: $adType}) {
    status
  }
}
    `;
export type DeleteAdMutationFn = Apollo.MutationFunction<DeleteAdMutation, DeleteAdMutationVariables>;

/**
 * __useDeleteAdMutation__
 *
 * To run a mutation, you first call `useDeleteAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdMutation, { data, loading, error }] = useDeleteAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useDeleteAdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdMutation, DeleteAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdMutation, DeleteAdMutationVariables>(DeleteAdDocument, options);
      }
export type DeleteAdMutationHookResult = ReturnType<typeof useDeleteAdMutation>;
export type DeleteAdMutationResult = Apollo.MutationResult<DeleteAdMutation>;
export type DeleteAdMutationOptions = Apollo.BaseMutationOptions<DeleteAdMutation, DeleteAdMutationVariables>;
export const SwitchActivateAdDocument = gql`
    mutation SwitchActivateAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
  switchActivationAd(input: {id: $id, adType: $adType}) {
    ad {
      __typename
      ... on Vacancy {
        id
        activatable
      }
      ... on Resume {
        id
        activatable
      }
    }
    status
  }
}
    `;
export type SwitchActivateAdMutationFn = Apollo.MutationFunction<SwitchActivateAdMutation, SwitchActivateAdMutationVariables>;

/**
 * __useSwitchActivateAdMutation__
 *
 * To run a mutation, you first call `useSwitchActivateAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchActivateAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchActivateAdMutation, { data, loading, error }] = useSwitchActivateAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useSwitchActivateAdMutation(baseOptions?: Apollo.MutationHookOptions<SwitchActivateAdMutation, SwitchActivateAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchActivateAdMutation, SwitchActivateAdMutationVariables>(SwitchActivateAdDocument, options);
      }
export type SwitchActivateAdMutationHookResult = ReturnType<typeof useSwitchActivateAdMutation>;
export type SwitchActivateAdMutationResult = Apollo.MutationResult<SwitchActivateAdMutation>;
export type SwitchActivateAdMutationOptions = Apollo.BaseMutationOptions<SwitchActivateAdMutation, SwitchActivateAdMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signIn(input: {email: $email, password: $password}) {
    status
    lockExpiresAt
    profile {
      ... on UserProfile {
        email
        id
        company {
          id
        }
        candidate {
          id
        }
      }
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SendEmailOtpCodeDocument = gql`
    mutation SendEmailOtpCode($email: String!) {
  sendEmailOtpCode(input: {email: $email}) {
    status
    usePassword
    lockExpiresAt
    errors {
      code
      message
      path
    }
  }
}
    `;
export type SendEmailOtpCodeMutationFn = Apollo.MutationFunction<SendEmailOtpCodeMutation, SendEmailOtpCodeMutationVariables>;

/**
 * __useSendEmailOtpCodeMutation__
 *
 * To run a mutation, you first call `useSendEmailOtpCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailOtpCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailOtpCodeMutation, { data, loading, error }] = useSendEmailOtpCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendEmailOtpCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailOtpCodeMutation, SendEmailOtpCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailOtpCodeMutation, SendEmailOtpCodeMutationVariables>(SendEmailOtpCodeDocument, options);
      }
export type SendEmailOtpCodeMutationHookResult = ReturnType<typeof useSendEmailOtpCodeMutation>;
export type SendEmailOtpCodeMutationResult = Apollo.MutationResult<SendEmailOtpCodeMutation>;
export type SendEmailOtpCodeMutationOptions = Apollo.BaseMutationOptions<SendEmailOtpCodeMutation, SendEmailOtpCodeMutationVariables>;
export const VerifyEmailOtpCodeDocument = gql`
    mutation VerifyEmailOtpCode($email: String!, $code: String!) {
  verifyEmailOtpCode(input: {email: $email, code: $code}) {
    status
    persisted
    lockExpiresAt
    profile {
      ... on UserProfile {
        email
        id
        company {
          id
        }
        candidate {
          id
        }
      }
    }
  }
}
    `;
export type VerifyEmailOtpCodeMutationFn = Apollo.MutationFunction<VerifyEmailOtpCodeMutation, VerifyEmailOtpCodeMutationVariables>;

/**
 * __useVerifyEmailOtpCodeMutation__
 *
 * To run a mutation, you first call `useVerifyEmailOtpCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailOtpCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailOtpCodeMutation, { data, loading, error }] = useVerifyEmailOtpCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyEmailOtpCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailOtpCodeMutation, VerifyEmailOtpCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailOtpCodeMutation, VerifyEmailOtpCodeMutationVariables>(VerifyEmailOtpCodeDocument, options);
      }
export type VerifyEmailOtpCodeMutationHookResult = ReturnType<typeof useVerifyEmailOtpCodeMutation>;
export type VerifyEmailOtpCodeMutationResult = Apollo.MutationResult<VerifyEmailOtpCodeMutation>;
export type VerifyEmailOtpCodeMutationOptions = Apollo.BaseMutationOptions<VerifyEmailOtpCodeMutation, VerifyEmailOtpCodeMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($email: String!, $name: String!, $profile: ProfileEnum!) {
  signUp(input: {email: $email, name: $name, profile: $profile}) {
    status
    profile {
      ... on UserProfile {
        email
        id
      }
    }
    errors {
      code
      message
      path
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SendResetPasswordDocument = gql`
    mutation SendResetPassword($email: String!) {
  sendResetPassword(input: {email: $email}) {
    status
  }
}
    `;
export type SendResetPasswordMutationFn = Apollo.MutationFunction<SendResetPasswordMutation, SendResetPasswordMutationVariables>;

/**
 * __useSendResetPasswordMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordMutation, { data, loading, error }] = useSendResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordMutation, SendResetPasswordMutationVariables>(SendResetPasswordDocument, options);
      }
export type SendResetPasswordMutationHookResult = ReturnType<typeof useSendResetPasswordMutation>;
export type SendResetPasswordMutationResult = Apollo.MutationResult<SendResetPasswordMutation>;
export type SendResetPasswordMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  signOut {
    status
  }
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const FastSignUpCompanyDocument = gql`
    mutation FastSignUpCompany($phone: String!, $name: String!, $email: String!, $contact: String!) {
  fastSignUpCompany(
    input: {phone: $phone, name: $name, email: $email, contact: $contact}
  ) {
    email
    status
    profile {
      ... on UserProfile {
        email
        id
      }
    }
    errors {
      code
      message
      path
    }
  }
}
    `;
export type FastSignUpCompanyMutationFn = Apollo.MutationFunction<FastSignUpCompanyMutation, FastSignUpCompanyMutationVariables>;

/**
 * __useFastSignUpCompanyMutation__
 *
 * To run a mutation, you first call `useFastSignUpCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFastSignUpCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fastSignUpCompanyMutation, { data, loading, error }] = useFastSignUpCompanyMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useFastSignUpCompanyMutation(baseOptions?: Apollo.MutationHookOptions<FastSignUpCompanyMutation, FastSignUpCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FastSignUpCompanyMutation, FastSignUpCompanyMutationVariables>(FastSignUpCompanyDocument, options);
      }
export type FastSignUpCompanyMutationHookResult = ReturnType<typeof useFastSignUpCompanyMutation>;
export type FastSignUpCompanyMutationResult = Apollo.MutationResult<FastSignUpCompanyMutation>;
export type FastSignUpCompanyMutationOptions = Apollo.BaseMutationOptions<FastSignUpCompanyMutation, FastSignUpCompanyMutationVariables>;
export const FastSignUpCandidateDocument = gql`
    mutation FastSignUpCandidate($input: CandidateFastSignUpInput!) {
  fastSignUpCandidate(input: $input) {
    email
    status
    profile {
      ... on UserProfile {
        email
        id
      }
    }
    errors {
      code
      message
      path
    }
  }
}
    `;
export type FastSignUpCandidateMutationFn = Apollo.MutationFunction<FastSignUpCandidateMutation, FastSignUpCandidateMutationVariables>;

/**
 * __useFastSignUpCandidateMutation__
 *
 * To run a mutation, you first call `useFastSignUpCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFastSignUpCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fastSignUpCandidateMutation, { data, loading, error }] = useFastSignUpCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFastSignUpCandidateMutation(baseOptions?: Apollo.MutationHookOptions<FastSignUpCandidateMutation, FastSignUpCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FastSignUpCandidateMutation, FastSignUpCandidateMutationVariables>(FastSignUpCandidateDocument, options);
      }
export type FastSignUpCandidateMutationHookResult = ReturnType<typeof useFastSignUpCandidateMutation>;
export type FastSignUpCandidateMutationResult = Apollo.MutationResult<FastSignUpCandidateMutation>;
export type FastSignUpCandidateMutationOptions = Apollo.BaseMutationOptions<FastSignUpCandidateMutation, FastSignUpCandidateMutationVariables>;
export const MinimalSignUpCandidateDocument = gql`
    mutation MinimalSignUpCandidate($input: CandidateMinimalSignUpInput!) {
  minimalSignUpCandidate(input: $input) {
    email
    status
    profile {
      ... on UserProfile {
        email
        id
      }
    }
    errors {
      code
      message
      path
    }
  }
}
    `;
export type MinimalSignUpCandidateMutationFn = Apollo.MutationFunction<MinimalSignUpCandidateMutation, MinimalSignUpCandidateMutationVariables>;

/**
 * __useMinimalSignUpCandidateMutation__
 *
 * To run a mutation, you first call `useMinimalSignUpCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMinimalSignUpCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [minimalSignUpCandidateMutation, { data, loading, error }] = useMinimalSignUpCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMinimalSignUpCandidateMutation(baseOptions?: Apollo.MutationHookOptions<MinimalSignUpCandidateMutation, MinimalSignUpCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MinimalSignUpCandidateMutation, MinimalSignUpCandidateMutationVariables>(MinimalSignUpCandidateDocument, options);
      }
export type MinimalSignUpCandidateMutationHookResult = ReturnType<typeof useMinimalSignUpCandidateMutation>;
export type MinimalSignUpCandidateMutationResult = Apollo.MutationResult<MinimalSignUpCandidateMutation>;
export type MinimalSignUpCandidateMutationOptions = Apollo.BaseMutationOptions<MinimalSignUpCandidateMutation, MinimalSignUpCandidateMutationVariables>;
export const CreateBookmarkDocument = gql`
    mutation CreateBookmark($id: ID!, $adType: AdTypeEnum!) {
  createBookmark(input: {id: $id, adType: $adType}) {
    status
    bookmark {
      id
    }
  }
}
    `;
export type CreateBookmarkMutationFn = Apollo.MutationFunction<CreateBookmarkMutation, CreateBookmarkMutationVariables>;

/**
 * __useCreateBookmarkMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkMutation, { data, loading, error }] = useCreateBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useCreateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkMutation, CreateBookmarkMutationVariables>(CreateBookmarkDocument, options);
      }
export type CreateBookmarkMutationHookResult = ReturnType<typeof useCreateBookmarkMutation>;
export type CreateBookmarkMutationResult = Apollo.MutationResult<CreateBookmarkMutation>;
export type CreateBookmarkMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>;
export const DeleteBookmarkDocument = gql`
    mutation DeleteBookmark($id: ID!, $adType: AdTypeEnum!) {
  deleteBookmark(input: {id: $id, adType: $adType}) {
    status
  }
}
    `;
export type DeleteBookmarkMutationFn = Apollo.MutationFunction<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;

/**
 * __useDeleteBookmarkMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkMutation, { data, loading, error }] = useDeleteBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useDeleteBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>(DeleteBookmarkDocument, options);
      }
export type DeleteBookmarkMutationHookResult = ReturnType<typeof useDeleteBookmarkMutation>;
export type DeleteBookmarkMutationResult = Apollo.MutationResult<DeleteBookmarkMutation>;
export type DeleteBookmarkMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;
export const CreateJobApplicationDocument = gql`
    mutation CreateJobApplication($vacancyId: ID!, $fullName: String!, $body: String, $file: Upload, $link: String, $resumeId: ID) {
  createJobApplication(
    input: {vacancyId: $vacancyId, fullName: $fullName, body: $body, file: $file, link: $link, resumeId: $resumeId}
  ) {
    errors {
      message
    }
    status
  }
}
    `;
export type CreateJobApplicationMutationFn = Apollo.MutationFunction<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;

/**
 * __useCreateJobApplicationMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationMutation, { data, loading, error }] = useCreateJobApplicationMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      fullName: // value for 'fullName'
 *      body: // value for 'body'
 *      file: // value for 'file'
 *      link: // value for 'link'
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useCreateJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>(CreateJobApplicationDocument, options);
      }
export type CreateJobApplicationMutationHookResult = ReturnType<typeof useCreateJobApplicationMutation>;
export type CreateJobApplicationMutationResult = Apollo.MutationResult<CreateJobApplicationMutation>;
export type CreateJobApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($paidServiceId: ID!, $paymentMethodId: PaymentMethodEnum!, $platform: MediumEnum, $targetId: ID, $targetType: AdTypeEnum, $amount: Int, $yigimTemplateGroup: PaymentCreateYigimTemplateGroupEnum) {
  createPayment(
    input: {paidServiceId: $paidServiceId, paymentMethodId: $paymentMethodId, platform: $platform, targetId: $targetId, targetType: $targetType, amount: $amount, yigimTemplateGroup: $yigimTemplateGroup}
  ) {
    paymentResult {
      paymentDate
      paymentId
      redirectUrl
      status
      targetId
      targetType
      errors {
        code
        message
        path
      }
    }
  }
}
    `;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      paidServiceId: // value for 'paidServiceId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      platform: // value for 'platform'
 *      targetId: // value for 'targetId'
 *      targetType: // value for 'targetType'
 *      amount: // value for 'amount'
 *      yigimTemplateGroup: // value for 'yigimTemplateGroup'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CreateResumeDocument = gql`
    mutation CreateResume($categoryId: ID, $dateOfBirth: ISO8601Date, $description: String, $email: String, $educationId: ID, $experienceId: ID, $firstName: String, $gender: GenderEnum, $patronymic: String, $personal: String, $phones: [String!], $photo: Upload, $positionName: String, $regionId: ID, $salaryFrom: Int, $skills: String, $surname: String, $educationInfo: String, $experienceInfo: String, $isDraft: Boolean) {
  createResume(
    input: {categoryId: $categoryId, dateOfBirth: $dateOfBirth, description: $description, email: $email, educationId: $educationId, experienceId: $experienceId, firstName: $firstName, gender: $gender, patronymic: $patronymic, personal: $personal, phones: $phones, photo: $photo, positionName: $positionName, regionId: $regionId, salaryFrom: $salaryFrom, skills: $skills, surname: $surname, educationInfo: $educationInfo, experienceInfo: $experienceInfo, isDraft: $isDraft}
  ) {
    status
    ad {
      approvedAt
      bumpedAt
      categoryId
      createdAt
      daysLeft
      deletable
      draft
      education
      educationId
      educationInfo
      experience
      experienceId
      experienceInfo
      expirable
      hits
      id
      isBookmarked
      isBumped
      isFeatured
      isMine
      location
      logo
      name
      personal
      positionName
      regionId
      rejectReason
      salaryFrom
      salaryTo
      skills
      status
      updatedAt
      awaitingPayment
      dateOfBirth
      description
    }
    errors {
      code
      message
      path
    }
  }
}
    `;
export type CreateResumeMutationFn = Apollo.MutationFunction<CreateResumeMutation, CreateResumeMutationVariables>;

/**
 * __useCreateResumeMutation__
 *
 * To run a mutation, you first call `useCreateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResumeMutation, { data, loading, error }] = useCreateResumeMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      description: // value for 'description'
 *      email: // value for 'email'
 *      educationId: // value for 'educationId'
 *      experienceId: // value for 'experienceId'
 *      firstName: // value for 'firstName'
 *      gender: // value for 'gender'
 *      patronymic: // value for 'patronymic'
 *      personal: // value for 'personal'
 *      phones: // value for 'phones'
 *      photo: // value for 'photo'
 *      positionName: // value for 'positionName'
 *      regionId: // value for 'regionId'
 *      salaryFrom: // value for 'salaryFrom'
 *      skills: // value for 'skills'
 *      surname: // value for 'surname'
 *      educationInfo: // value for 'educationInfo'
 *      experienceInfo: // value for 'experienceInfo'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useCreateResumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateResumeMutation, CreateResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResumeMutation, CreateResumeMutationVariables>(CreateResumeDocument, options);
      }
export type CreateResumeMutationHookResult = ReturnType<typeof useCreateResumeMutation>;
export type CreateResumeMutationResult = Apollo.MutationResult<CreateResumeMutation>;
export type CreateResumeMutationOptions = Apollo.BaseMutationOptions<CreateResumeMutation, CreateResumeMutationVariables>;
export const FreeActivateResumeDocument = gql`
    mutation FreeActivateResume($id: ID!) {
  freeActivateResume(id: $id) {
    status
    errors {
      code
      message
      path
    }
  }
}
    `;
export type FreeActivateResumeMutationFn = Apollo.MutationFunction<FreeActivateResumeMutation, FreeActivateResumeMutationVariables>;

/**
 * __useFreeActivateResumeMutation__
 *
 * To run a mutation, you first call `useFreeActivateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreeActivateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freeActivateResumeMutation, { data, loading, error }] = useFreeActivateResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFreeActivateResumeMutation(baseOptions?: Apollo.MutationHookOptions<FreeActivateResumeMutation, FreeActivateResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreeActivateResumeMutation, FreeActivateResumeMutationVariables>(FreeActivateResumeDocument, options);
      }
export type FreeActivateResumeMutationHookResult = ReturnType<typeof useFreeActivateResumeMutation>;
export type FreeActivateResumeMutationResult = Apollo.MutationResult<FreeActivateResumeMutation>;
export type FreeActivateResumeMutationOptions = Apollo.BaseMutationOptions<FreeActivateResumeMutation, FreeActivateResumeMutationVariables>;
export const DeleteAdResumeDocument = gql`
    mutation DeleteAdResume($id: ID!, $adType: AdTypeEnum = RESUME) {
  deleteAd(input: {id: $id, adType: $adType}) {
    status
  }
}
    `;
export type DeleteAdResumeMutationFn = Apollo.MutationFunction<DeleteAdResumeMutation, DeleteAdResumeMutationVariables>;

/**
 * __useDeleteAdResumeMutation__
 *
 * To run a mutation, you first call `useDeleteAdResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdResumeMutation, { data, loading, error }] = useDeleteAdResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useDeleteAdResumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdResumeMutation, DeleteAdResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdResumeMutation, DeleteAdResumeMutationVariables>(DeleteAdResumeDocument, options);
      }
export type DeleteAdResumeMutationHookResult = ReturnType<typeof useDeleteAdResumeMutation>;
export type DeleteAdResumeMutationResult = Apollo.MutationResult<DeleteAdResumeMutation>;
export type DeleteAdResumeMutationOptions = Apollo.BaseMutationOptions<DeleteAdResumeMutation, DeleteAdResumeMutationVariables>;
export const CreateBookmarkResumeDocument = gql`
    mutation createBookmarkResume($adId: ID!, $adType: AdTypeEnum = RESUME) {
  createBookmark(input: {id: $adId, adType: $adType}) {
    status
  }
}
    `;
export type CreateBookmarkResumeMutationFn = Apollo.MutationFunction<CreateBookmarkResumeMutation, CreateBookmarkResumeMutationVariables>;

/**
 * __useCreateBookmarkResumeMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkResumeMutation, { data, loading, error }] = useCreateBookmarkResumeMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useCreateBookmarkResumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkResumeMutation, CreateBookmarkResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkResumeMutation, CreateBookmarkResumeMutationVariables>(CreateBookmarkResumeDocument, options);
      }
export type CreateBookmarkResumeMutationHookResult = ReturnType<typeof useCreateBookmarkResumeMutation>;
export type CreateBookmarkResumeMutationResult = Apollo.MutationResult<CreateBookmarkResumeMutation>;
export type CreateBookmarkResumeMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkResumeMutation, CreateBookmarkResumeMutationVariables>;
export const DeleteBookmarkResumeDocument = gql`
    mutation deleteBookmarkResume($adId: ID!, $adType: AdTypeEnum = RESUME) {
  deleteBookmark(input: {id: $adId, adType: $adType}) {
    status
  }
}
    `;
export type DeleteBookmarkResumeMutationFn = Apollo.MutationFunction<DeleteBookmarkResumeMutation, DeleteBookmarkResumeMutationVariables>;

/**
 * __useDeleteBookmarkResumeMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkResumeMutation, { data, loading, error }] = useDeleteBookmarkResumeMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useDeleteBookmarkResumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkResumeMutation, DeleteBookmarkResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkResumeMutation, DeleteBookmarkResumeMutationVariables>(DeleteBookmarkResumeDocument, options);
      }
export type DeleteBookmarkResumeMutationHookResult = ReturnType<typeof useDeleteBookmarkResumeMutation>;
export type DeleteBookmarkResumeMutationResult = Apollo.MutationResult<DeleteBookmarkResumeMutation>;
export type DeleteBookmarkResumeMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkResumeMutation, DeleteBookmarkResumeMutationVariables>;
export const CreateVacancyDocument = gql`
    mutation CreateVacancy($ageFrom: Int, $ageTo: Int, $categoryId: ID, $contact: String, $description: String, $educationId: ID, $experienceId: ID, $positionName: String, $regionId: ID, $salaryFrom: Int, $salaryTo: Int, $isDraft: Boolean, $phones: [String!], $email: String) {
  createVacancy(
    input: {ageFrom: $ageFrom, ageTo: $ageTo, categoryId: $categoryId, contact: $contact, description: $description, educationId: $educationId, experienceId: $experienceId, positionName: $positionName, regionId: $regionId, salaryFrom: $salaryFrom, salaryTo: $salaryTo, isDraft: $isDraft, phones: $phones, email: $email}
  ) {
    status
    errors {
      code
      message
      path
    }
    ad {
      ageFrom
      ageTo
      approvedAt
      awaitingPayment
      bumpedAt
      categoryId
      createdAt
      contactName
      daysLeft
      deletable
      description
      draft
      education
      educationId
      experience
      experienceId
      expirable
      isBookmarked
      isBumped
      isFeatured
      isMine
      jobDescription
      location
      logo
      name
      positionName
      regionId
      rejectReason
      requirements
      responsibilities
      salaryFrom
      salaryTo
      status
      updatedAt
      id
      phones
      email
    }
  }
}
    `;
export type CreateVacancyMutationFn = Apollo.MutationFunction<CreateVacancyMutation, CreateVacancyMutationVariables>;

/**
 * __useCreateVacancyMutation__
 *
 * To run a mutation, you first call `useCreateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyMutation, { data, loading, error }] = useCreateVacancyMutation({
 *   variables: {
 *      ageFrom: // value for 'ageFrom'
 *      ageTo: // value for 'ageTo'
 *      categoryId: // value for 'categoryId'
 *      contact: // value for 'contact'
 *      description: // value for 'description'
 *      educationId: // value for 'educationId'
 *      experienceId: // value for 'experienceId'
 *      positionName: // value for 'positionName'
 *      regionId: // value for 'regionId'
 *      salaryFrom: // value for 'salaryFrom'
 *      salaryTo: // value for 'salaryTo'
 *      isDraft: // value for 'isDraft'
 *      phones: // value for 'phones'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyMutation, CreateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyMutation, CreateVacancyMutationVariables>(CreateVacancyDocument, options);
      }
export type CreateVacancyMutationHookResult = ReturnType<typeof useCreateVacancyMutation>;
export type CreateVacancyMutationResult = Apollo.MutationResult<CreateVacancyMutation>;
export type CreateVacancyMutationOptions = Apollo.BaseMutationOptions<CreateVacancyMutation, CreateVacancyMutationVariables>;
export const CreateBookmarkVacancyDocument = gql`
    mutation createBookmarkVacancy($adId: ID!, $adType: AdTypeEnum = VACANCY) {
  createBookmark(input: {id: $adId, adType: $adType}) {
    status
  }
}
    `;
export type CreateBookmarkVacancyMutationFn = Apollo.MutationFunction<CreateBookmarkVacancyMutation, CreateBookmarkVacancyMutationVariables>;

/**
 * __useCreateBookmarkVacancyMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkVacancyMutation, { data, loading, error }] = useCreateBookmarkVacancyMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useCreateBookmarkVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkVacancyMutation, CreateBookmarkVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkVacancyMutation, CreateBookmarkVacancyMutationVariables>(CreateBookmarkVacancyDocument, options);
      }
export type CreateBookmarkVacancyMutationHookResult = ReturnType<typeof useCreateBookmarkVacancyMutation>;
export type CreateBookmarkVacancyMutationResult = Apollo.MutationResult<CreateBookmarkVacancyMutation>;
export type CreateBookmarkVacancyMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkVacancyMutation, CreateBookmarkVacancyMutationVariables>;
export const DeleteBookmarkVacancyDocument = gql`
    mutation deleteBookmarkVacancy($adId: ID!, $adType: AdTypeEnum = VACANCY) {
  deleteBookmark(input: {id: $adId, adType: $adType}) {
    status
  }
}
    `;
export type DeleteBookmarkVacancyMutationFn = Apollo.MutationFunction<DeleteBookmarkVacancyMutation, DeleteBookmarkVacancyMutationVariables>;

/**
 * __useDeleteBookmarkVacancyMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkVacancyMutation, { data, loading, error }] = useDeleteBookmarkVacancyMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useDeleteBookmarkVacancyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkVacancyMutation, DeleteBookmarkVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkVacancyMutation, DeleteBookmarkVacancyMutationVariables>(DeleteBookmarkVacancyDocument, options);
      }
export type DeleteBookmarkVacancyMutationHookResult = ReturnType<typeof useDeleteBookmarkVacancyMutation>;
export type DeleteBookmarkVacancyMutationResult = Apollo.MutationResult<DeleteBookmarkVacancyMutation>;
export type DeleteBookmarkVacancyMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkVacancyMutation, DeleteBookmarkVacancyMutationVariables>;
export const FreeActivateVacancyDocument = gql`
    mutation FreeActivateVacancy($id: ID!) {
  freeActivateVacancy(id: $id) {
    status
    errors {
      code
      message
      path
    }
  }
}
    `;
export type FreeActivateVacancyMutationFn = Apollo.MutationFunction<FreeActivateVacancyMutation, FreeActivateVacancyMutationVariables>;

/**
 * __useFreeActivateVacancyMutation__
 *
 * To run a mutation, you first call `useFreeActivateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreeActivateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freeActivateVacancyMutation, { data, loading, error }] = useFreeActivateVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFreeActivateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<FreeActivateVacancyMutation, FreeActivateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreeActivateVacancyMutation, FreeActivateVacancyMutationVariables>(FreeActivateVacancyDocument, options);
      }
export type FreeActivateVacancyMutationHookResult = ReturnType<typeof useFreeActivateVacancyMutation>;
export type FreeActivateVacancyMutationResult = Apollo.MutationResult<FreeActivateVacancyMutation>;
export type FreeActivateVacancyMutationOptions = Apollo.BaseMutationOptions<FreeActivateVacancyMutation, FreeActivateVacancyMutationVariables>;
export const AdsDocument = gql`
    query Ads($state: ProfileAdTabStatesEnum!, $after: String, $before: String, $first: Int, $last: Int, $adType: AdTypeEnum) {
  profile {
    ... on UserProfile {
      ads(
        state: $state
        after: $after
        before: $before
        first: $first
        last: $last
        adType: $adType
      ) {
        nodes {
          ... on Resume {
            ...resumeCardFields
          }
          ... on Vacancy {
            ...vacancyCardFields
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
}
    ${ResumeCardFieldsFragmentDoc}
${VacancyCardFieldsFragmentDoc}`;

/**
 * __useAdsQuery__
 *
 * To run a query within a React component, call `useAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useAdsQuery(baseOptions: Apollo.QueryHookOptions<AdsQuery, AdsQueryVariables> & ({ variables: AdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdsQuery, AdsQueryVariables>(AdsDocument, options);
      }
export function useAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdsQuery, AdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdsQuery, AdsQueryVariables>(AdsDocument, options);
        }
// @ts-ignore
export function useAdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdsQuery, AdsQueryVariables>): Apollo.UseSuspenseQueryResult<AdsQuery, AdsQueryVariables>;
export function useAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdsQuery, AdsQueryVariables>): Apollo.UseSuspenseQueryResult<AdsQuery | undefined, AdsQueryVariables>;
export function useAdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdsQuery, AdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdsQuery, AdsQueryVariables>(AdsDocument, options);
        }
export type AdsQueryHookResult = ReturnType<typeof useAdsQuery>;
export type AdsLazyQueryHookResult = ReturnType<typeof useAdsLazyQuery>;
export type AdsSuspenseQueryHookResult = ReturnType<typeof useAdsSuspenseQuery>;
export type AdsQueryResult = Apollo.QueryResult<AdsQuery, AdsQueryVariables>;
export const VacanciesDocument = gql`
    query Vacancies($filter: AdFilter, $scope: AdScopeEnum, $after: String, $before: String, $first: Int, $last: Int, $sortBy: AdSortByEnum) {
  vacancies(
    filter: $filter
    scope: $scope
    after: $after
    before: $before
    first: $first
    last: $last
    sortBy: $sortBy
  ) {
    totalCount
    edges {
      cursor
    }
    nodes {
      ...vacancyCardFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${VacancyCardFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useVacanciesQuery__
 *
 * To run a query within a React component, call `useVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      scope: // value for 'scope'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
      }
export function useVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
        }
// @ts-ignore
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesQuery, VacanciesQueryVariables>;
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesQuery | undefined, VacanciesQueryVariables>;
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
        }
export type VacanciesQueryHookResult = ReturnType<typeof useVacanciesQuery>;
export type VacanciesLazyQueryHookResult = ReturnType<typeof useVacanciesLazyQuery>;
export type VacanciesSuspenseQueryHookResult = ReturnType<typeof useVacanciesSuspenseQuery>;
export type VacanciesQueryResult = Apollo.QueryResult<VacanciesQuery, VacanciesQueryVariables>;
export const ResumesDocument = gql`
    query Resumes($filter: AdFilter, $scope: AdScopeEnum, $after: String, $before: String, $first: Int, $last: Int, $sortBy: AdSortByEnum) {
  resumes(
    filter: $filter
    scope: $scope
    after: $after
    before: $before
    first: $first
    last: $last
    sortBy: $sortBy
  ) {
    totalCount
    edges {
      cursor
      node {
        ...resumeCardFields
      }
    }
    nodes {
      ...resumeCardFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${ResumeCardFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useResumesQuery__
 *
 * To run a query within a React component, call `useResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      scope: // value for 'scope'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useResumesQuery(baseOptions?: Apollo.QueryHookOptions<ResumesQuery, ResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResumesQuery, ResumesQueryVariables>(ResumesDocument, options);
      }
export function useResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResumesQuery, ResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResumesQuery, ResumesQueryVariables>(ResumesDocument, options);
        }
// @ts-ignore
export function useResumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResumesQuery, ResumesQueryVariables>): Apollo.UseSuspenseQueryResult<ResumesQuery, ResumesQueryVariables>;
export function useResumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumesQuery, ResumesQueryVariables>): Apollo.UseSuspenseQueryResult<ResumesQuery | undefined, ResumesQueryVariables>;
export function useResumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumesQuery, ResumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResumesQuery, ResumesQueryVariables>(ResumesDocument, options);
        }
export type ResumesQueryHookResult = ReturnType<typeof useResumesQuery>;
export type ResumesLazyQueryHookResult = ReturnType<typeof useResumesLazyQuery>;
export type ResumesSuspenseQueryHookResult = ReturnType<typeof useResumesSuspenseQuery>;
export type ResumesQueryResult = Apollo.QueryResult<ResumesQuery, ResumesQueryVariables>;
export const BookmarksDocument = gql`
    query Bookmarks($after: String, $before: String, $first: Int, $last: Int) {
  bookmarks(after: $after, before: $before, first: $first, last: $last) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
    }
    nodes {
      ad {
        ... on Vacancy {
          ...vacancyCardFields
        }
        ... on Resume {
          ...resumeCardFields
        }
      }
      id
    }
    totalCount
  }
}
    ${VacancyCardFieldsFragmentDoc}
${ResumeCardFieldsFragmentDoc}`;

/**
 * __useBookmarksQuery__
 *
 * To run a query within a React component, call `useBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookmarksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useBookmarksQuery(baseOptions?: Apollo.QueryHookOptions<BookmarksQuery, BookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookmarksQuery, BookmarksQueryVariables>(BookmarksDocument, options);
      }
export function useBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookmarksQuery, BookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookmarksQuery, BookmarksQueryVariables>(BookmarksDocument, options);
        }
// @ts-ignore
export function useBookmarksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookmarksQuery, BookmarksQueryVariables>): Apollo.UseSuspenseQueryResult<BookmarksQuery, BookmarksQueryVariables>;
export function useBookmarksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookmarksQuery, BookmarksQueryVariables>): Apollo.UseSuspenseQueryResult<BookmarksQuery | undefined, BookmarksQueryVariables>;
export function useBookmarksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookmarksQuery, BookmarksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookmarksQuery, BookmarksQueryVariables>(BookmarksDocument, options);
        }
export type BookmarksQueryHookResult = ReturnType<typeof useBookmarksQuery>;
export type BookmarksLazyQueryHookResult = ReturnType<typeof useBookmarksLazyQuery>;
export type BookmarksSuspenseQueryHookResult = ReturnType<typeof useBookmarksSuspenseQuery>;
export type BookmarksQueryResult = Apollo.QueryResult<BookmarksQuery, BookmarksQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($includeChildren: Boolean! = true) {
  categories {
    id
    name
    children @include(if: $includeChildren) {
      id
      name
      parentId
    }
    parentId
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      includeChildren: // value for 'includeChildren'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
// @ts-ignore
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<CategoriesQuery, CategoriesQueryVariables>;
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<CategoriesQuery | undefined, CategoriesQueryVariables>;
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CompanyNameDocument = gql`
    query CompanyName($id: ID!) {
  company(id: $id) {
    name
  }
}
    `;

/**
 * __useCompanyNameQuery__
 *
 * To run a query within a React component, call `useCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyNameQuery(baseOptions: Apollo.QueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables> & ({ variables: CompanyNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
      }
export function useCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
        }
// @ts-ignore
export function useCompanyNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyNameQuery, CompanyNameQueryVariables>;
export function useCompanyNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyNameQuery | undefined, CompanyNameQueryVariables>;
export function useCompanyNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
        }
export type CompanyNameQueryHookResult = ReturnType<typeof useCompanyNameQuery>;
export type CompanyNameLazyQueryHookResult = ReturnType<typeof useCompanyNameLazyQuery>;
export type CompanyNameSuspenseQueryHookResult = ReturnType<typeof useCompanyNameSuspenseQuery>;
export type CompanyNameQueryResult = Apollo.QueryResult<CompanyNameQuery, CompanyNameQueryVariables>;
export const CompanyDocument = gql`
    query Company($id: ID!) {
  company(id: $id) {
    ...companyFields
    publishedCount
    regionId
    regionName
    specializationName
    ads {
      ...vacancyCardFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}
${VacancyCardFieldsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
// @ts-ignore
export function useCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyQuery, CompanyQueryVariables>;
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyQuery | undefined, CompanyQueryVariables>;
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const EmptyQueryDocument = gql`
    query EmptyQuery {
  __typename
}
    `;

/**
 * __useEmptyQueryQuery__
 *
 * To run a query within a React component, call `useEmptyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmptyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptyQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmptyQueryQuery(baseOptions?: Apollo.QueryHookOptions<EmptyQueryQuery, EmptyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmptyQueryQuery, EmptyQueryQueryVariables>(EmptyQueryDocument, options);
      }
export function useEmptyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmptyQueryQuery, EmptyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmptyQueryQuery, EmptyQueryQueryVariables>(EmptyQueryDocument, options);
        }
// @ts-ignore
export function useEmptyQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmptyQueryQuery, EmptyQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EmptyQueryQuery, EmptyQueryQueryVariables>;
export function useEmptyQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmptyQueryQuery, EmptyQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EmptyQueryQuery | undefined, EmptyQueryQueryVariables>;
export function useEmptyQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmptyQueryQuery, EmptyQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmptyQueryQuery, EmptyQueryQueryVariables>(EmptyQueryDocument, options);
        }
export type EmptyQueryQueryHookResult = ReturnType<typeof useEmptyQueryQuery>;
export type EmptyQueryLazyQueryHookResult = ReturnType<typeof useEmptyQueryLazyQuery>;
export type EmptyQuerySuspenseQueryHookResult = ReturnType<typeof useEmptyQuerySuspenseQuery>;
export type EmptyQueryQueryResult = Apollo.QueryResult<EmptyQueryQuery, EmptyQueryQueryVariables>;
export const PagesDocument = gql`
    query Pages {
  pages {
    slug
    title
    id
  }
}
    `;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
// @ts-ignore
export function usePagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>): Apollo.UseSuspenseQueryResult<PagesQuery, PagesQueryVariables>;
export function usePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>): Apollo.UseSuspenseQueryResult<PagesQuery | undefined, PagesQueryVariables>;
export function usePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesSuspenseQueryHookResult = ReturnType<typeof usePagesSuspenseQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const PageDocument = gql`
    query Page($slug: String!) {
  page(slug: $slug) {
    bodyMarkdown
    id
    slug
    title
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables> & ({ variables: PageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
// @ts-ignore
export function usePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery | undefined, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const PaidServicesDocument = gql`
    query paidServices($targetType: PaidServiceTargetTypeEnum!, $targetId: ID) {
  paidServices(targetType: $targetType, targetId: $targetId) {
    description
    id
    targetType
    title
    options {
      ...PaidServiceOptionFields
    }
    paymentMethods {
      ...PaidServicePaymentMethodsFields
    }
  }
}
    ${PaidServiceOptionFieldsFragmentDoc}
${PaidServicePaymentMethodsFieldsFragmentDoc}`;

/**
 * __usePaidServicesQuery__
 *
 * To run a query within a React component, call `usePaidServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidServicesQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function usePaidServicesQuery(baseOptions: Apollo.QueryHookOptions<PaidServicesQuery, PaidServicesQueryVariables> & ({ variables: PaidServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaidServicesQuery, PaidServicesQueryVariables>(PaidServicesDocument, options);
      }
export function usePaidServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaidServicesQuery, PaidServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaidServicesQuery, PaidServicesQueryVariables>(PaidServicesDocument, options);
        }
// @ts-ignore
export function usePaidServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaidServicesQuery, PaidServicesQueryVariables>): Apollo.UseSuspenseQueryResult<PaidServicesQuery, PaidServicesQueryVariables>;
export function usePaidServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaidServicesQuery, PaidServicesQueryVariables>): Apollo.UseSuspenseQueryResult<PaidServicesQuery | undefined, PaidServicesQueryVariables>;
export function usePaidServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaidServicesQuery, PaidServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaidServicesQuery, PaidServicesQueryVariables>(PaidServicesDocument, options);
        }
export type PaidServicesQueryHookResult = ReturnType<typeof usePaidServicesQuery>;
export type PaidServicesLazyQueryHookResult = ReturnType<typeof usePaidServicesLazyQuery>;
export type PaidServicesSuspenseQueryHookResult = ReturnType<typeof usePaidServicesSuspenseQuery>;
export type PaidServicesQueryResult = Apollo.QueryResult<PaidServicesQuery, PaidServicesQueryVariables>;
export const GetPaymentDocument = gql`
    query GetPayment($signedId: String!) {
  payment(signedId: $signedId) {
    id
    amount
    targetId
    targetType
    message
    success
    finished
    serviceName
    serviceId
    updatedAt
    returnTo
    source
  }
}
    `;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      signedId: // value for 'signedId'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables> & ({ variables: GetPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
// @ts-ignore
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentQuery | undefined, GetPaymentQueryVariables>;
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSuspenseQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const ProfileFullDocument = gql`
    query ProfileFull($state: ProfileAdTabStatesEnum = ALL, $adType: AdTypeEnum = null) {
  profile {
    ... on UserProfile {
      id
      email
      walletBalance
      adsStateCounts(adType: $adType) {
        ...adsStateCounts
      }
      company {
        ...companyFields
      }
      ads(state: $state, adType: $adType) {
        nodes {
          ... on Resume {
            ...resumeCardFields
          }
          ... on Vacancy {
            ...vacancyCardFields
          }
        }
      }
      candidate {
        id
        firstName
        surname
        patronymic
        name
        gender
        age
        dateOfBirth
        email
        phones
        regionId
        educationId
        experienceId
        logoUrl
        __typename
      }
    }
  }
}
    ${AdsStateCountsFragmentDoc}
${CompanyFieldsFragmentDoc}
${ResumeCardFieldsFragmentDoc}
${VacancyCardFieldsFragmentDoc}`;

/**
 * __useProfileFullQuery__
 *
 * To run a query within a React component, call `useProfileFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileFullQuery({
 *   variables: {
 *      state: // value for 'state'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useProfileFullQuery(baseOptions?: Apollo.QueryHookOptions<ProfileFullQuery, ProfileFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileFullQuery, ProfileFullQueryVariables>(ProfileFullDocument, options);
      }
export function useProfileFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileFullQuery, ProfileFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileFullQuery, ProfileFullQueryVariables>(ProfileFullDocument, options);
        }
// @ts-ignore
export function useProfileFullSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileFullQuery, ProfileFullQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileFullQuery, ProfileFullQueryVariables>;
export function useProfileFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileFullQuery, ProfileFullQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileFullQuery | undefined, ProfileFullQueryVariables>;
export function useProfileFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileFullQuery, ProfileFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileFullQuery, ProfileFullQueryVariables>(ProfileFullDocument, options);
        }
export type ProfileFullQueryHookResult = ReturnType<typeof useProfileFullQuery>;
export type ProfileFullLazyQueryHookResult = ReturnType<typeof useProfileFullLazyQuery>;
export type ProfileFullSuspenseQueryHookResult = ReturnType<typeof useProfileFullSuspenseQuery>;
export type ProfileFullQueryResult = Apollo.QueryResult<ProfileFullQuery, ProfileFullQueryVariables>;
export const ProfileMinDocument = gql`
    query ProfileMin {
  profile {
    ... on UserProfile {
      id
      email
      walletBalance
      company {
        id
        logoUrl
        name
        phones
        email
        paidType
        postpaidLimit
      }
      candidate {
        id
        firstName
        surname
        logoUrl
        email
        phones
        patronymic
        gender
        dateOfBirth
        regionId
        regionName
      }
    }
  }
}
    `;

/**
 * __useProfileMinQuery__
 *
 * To run a query within a React component, call `useProfileMinQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileMinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileMinQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileMinQuery(baseOptions?: Apollo.QueryHookOptions<ProfileMinQuery, ProfileMinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileMinQuery, ProfileMinQueryVariables>(ProfileMinDocument, options);
      }
export function useProfileMinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileMinQuery, ProfileMinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileMinQuery, ProfileMinQueryVariables>(ProfileMinDocument, options);
        }
// @ts-ignore
export function useProfileMinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileMinQuery, ProfileMinQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileMinQuery, ProfileMinQueryVariables>;
export function useProfileMinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileMinQuery, ProfileMinQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileMinQuery | undefined, ProfileMinQueryVariables>;
export function useProfileMinSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileMinQuery, ProfileMinQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileMinQuery, ProfileMinQueryVariables>(ProfileMinDocument, options);
        }
export type ProfileMinQueryHookResult = ReturnType<typeof useProfileMinQuery>;
export type ProfileMinLazyQueryHookResult = ReturnType<typeof useProfileMinLazyQuery>;
export type ProfileMinSuspenseQueryHookResult = ReturnType<typeof useProfileMinSuspenseQuery>;
export type ProfileMinQueryResult = Apollo.QueryResult<ProfileMinQuery, ProfileMinQueryVariables>;
export const AdsStateCountsDocument = gql`
    query AdsStateCounts($adType: AdTypeEnum = null) {
  profile {
    ... on UserProfile {
      adsStateCounts(adType: $adType) {
        ...adsStateCounts
      }
    }
  }
}
    ${AdsStateCountsFragmentDoc}`;

/**
 * __useAdsStateCountsQuery__
 *
 * To run a query within a React component, call `useAdsStateCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsStateCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdsStateCountsQuery({
 *   variables: {
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useAdsStateCountsQuery(baseOptions?: Apollo.QueryHookOptions<AdsStateCountsQuery, AdsStateCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdsStateCountsQuery, AdsStateCountsQueryVariables>(AdsStateCountsDocument, options);
      }
export function useAdsStateCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdsStateCountsQuery, AdsStateCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdsStateCountsQuery, AdsStateCountsQueryVariables>(AdsStateCountsDocument, options);
        }
// @ts-ignore
export function useAdsStateCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdsStateCountsQuery, AdsStateCountsQueryVariables>): Apollo.UseSuspenseQueryResult<AdsStateCountsQuery, AdsStateCountsQueryVariables>;
export function useAdsStateCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdsStateCountsQuery, AdsStateCountsQueryVariables>): Apollo.UseSuspenseQueryResult<AdsStateCountsQuery | undefined, AdsStateCountsQueryVariables>;
export function useAdsStateCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdsStateCountsQuery, AdsStateCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdsStateCountsQuery, AdsStateCountsQueryVariables>(AdsStateCountsDocument, options);
        }
export type AdsStateCountsQueryHookResult = ReturnType<typeof useAdsStateCountsQuery>;
export type AdsStateCountsLazyQueryHookResult = ReturnType<typeof useAdsStateCountsLazyQuery>;
export type AdsStateCountsSuspenseQueryHookResult = ReturnType<typeof useAdsStateCountsSuspenseQuery>;
export type AdsStateCountsQueryResult = Apollo.QueryResult<AdsStateCountsQuery, AdsStateCountsQueryVariables>;
export const ResumeDocument = gql`
    query Resume($id: ID!) {
  resume(id: $id) {
    ...resumeFields
  }
}
    ${ResumeFieldsFragmentDoc}`;

/**
 * __useResumeQuery__
 *
 * To run a query within a React component, call `useResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeQuery(baseOptions: Apollo.QueryHookOptions<ResumeQuery, ResumeQueryVariables> & ({ variables: ResumeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResumeQuery, ResumeQueryVariables>(ResumeDocument, options);
      }
export function useResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResumeQuery, ResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResumeQuery, ResumeQueryVariables>(ResumeDocument, options);
        }
// @ts-ignore
export function useResumeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResumeQuery, ResumeQueryVariables>): Apollo.UseSuspenseQueryResult<ResumeQuery, ResumeQueryVariables>;
export function useResumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeQuery, ResumeQueryVariables>): Apollo.UseSuspenseQueryResult<ResumeQuery | undefined, ResumeQueryVariables>;
export function useResumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeQuery, ResumeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResumeQuery, ResumeQueryVariables>(ResumeDocument, options);
        }
export type ResumeQueryHookResult = ReturnType<typeof useResumeQuery>;
export type ResumeLazyQueryHookResult = ReturnType<typeof useResumeLazyQuery>;
export type ResumeSuspenseQueryHookResult = ReturnType<typeof useResumeSuspenseQuery>;
export type ResumeQueryResult = Apollo.QueryResult<ResumeQuery, ResumeQueryVariables>;
export const GetFeaturedResumesDocument = gql`
    query GetFeaturedResumes {
  resumes(scope: FEATURED, filter: {random: true}, first: 8) {
    edges {
      node {
        ...resumeCardFields
      }
    }
  }
}
    ${ResumeCardFieldsFragmentDoc}`;

/**
 * __useGetFeaturedResumesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedResumesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedResumesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>(GetFeaturedResumesDocument, options);
      }
export function useGetFeaturedResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>(GetFeaturedResumesDocument, options);
        }
// @ts-ignore
export function useGetFeaturedResumesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>;
export function useGetFeaturedResumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedResumesQuery | undefined, GetFeaturedResumesQueryVariables>;
export function useGetFeaturedResumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>(GetFeaturedResumesDocument, options);
        }
export type GetFeaturedResumesQueryHookResult = ReturnType<typeof useGetFeaturedResumesQuery>;
export type GetFeaturedResumesLazyQueryHookResult = ReturnType<typeof useGetFeaturedResumesLazyQuery>;
export type GetFeaturedResumesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedResumesSuspenseQuery>;
export type GetFeaturedResumesQueryResult = Apollo.QueryResult<GetFeaturedResumesQuery, GetFeaturedResumesQueryVariables>;
export const GetResumeDocument = gql`
    query GetResume($resumeId: ID!) {
  resume(id: $resumeId) {
    ...BaseResumeFields
    relatedAds {
      ...BaseResumeFields
    }
  }
}
    ${BaseResumeFieldsFragmentDoc}`;

/**
 * __useGetResumeQuery__
 *
 * To run a query within a React component, call `useGetResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeQuery({
 *   variables: {
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useGetResumeQuery(baseOptions: Apollo.QueryHookOptions<GetResumeQuery, GetResumeQueryVariables> & ({ variables: GetResumeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResumeQuery, GetResumeQueryVariables>(GetResumeDocument, options);
      }
export function useGetResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResumeQuery, GetResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResumeQuery, GetResumeQueryVariables>(GetResumeDocument, options);
        }
// @ts-ignore
export function useGetResumeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResumeQuery, GetResumeQueryVariables>): Apollo.UseSuspenseQueryResult<GetResumeQuery, GetResumeQueryVariables>;
export function useGetResumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResumeQuery, GetResumeQueryVariables>): Apollo.UseSuspenseQueryResult<GetResumeQuery | undefined, GetResumeQueryVariables>;
export function useGetResumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResumeQuery, GetResumeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResumeQuery, GetResumeQueryVariables>(GetResumeDocument, options);
        }
export type GetResumeQueryHookResult = ReturnType<typeof useGetResumeQuery>;
export type GetResumeLazyQueryHookResult = ReturnType<typeof useGetResumeLazyQuery>;
export type GetResumeSuspenseQueryHookResult = ReturnType<typeof useGetResumeSuspenseQuery>;
export type GetResumeQueryResult = Apollo.QueryResult<GetResumeQuery, GetResumeQueryVariables>;
export const EducationsDocument = gql`
    query Educations {
  educations {
    id
    name
  }
}
    `;

/**
 * __useEducationsQuery__
 *
 * To run a query within a React component, call `useEducationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEducationsQuery(baseOptions?: Apollo.QueryHookOptions<EducationsQuery, EducationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationsQuery, EducationsQueryVariables>(EducationsDocument, options);
      }
export function useEducationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationsQuery, EducationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationsQuery, EducationsQueryVariables>(EducationsDocument, options);
        }
// @ts-ignore
export function useEducationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EducationsQuery, EducationsQueryVariables>): Apollo.UseSuspenseQueryResult<EducationsQuery, EducationsQueryVariables>;
export function useEducationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EducationsQuery, EducationsQueryVariables>): Apollo.UseSuspenseQueryResult<EducationsQuery | undefined, EducationsQueryVariables>;
export function useEducationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EducationsQuery, EducationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EducationsQuery, EducationsQueryVariables>(EducationsDocument, options);
        }
export type EducationsQueryHookResult = ReturnType<typeof useEducationsQuery>;
export type EducationsLazyQueryHookResult = ReturnType<typeof useEducationsLazyQuery>;
export type EducationsSuspenseQueryHookResult = ReturnType<typeof useEducationsSuspenseQuery>;
export type EducationsQueryResult = Apollo.QueryResult<EducationsQuery, EducationsQueryVariables>;
export const ExperiencesDocument = gql`
    query Experiences {
  experiences {
    id
    name
  }
}
    `;

/**
 * __useExperiencesQuery__
 *
 * To run a query within a React component, call `useExperiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperiencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExperiencesQuery(baseOptions?: Apollo.QueryHookOptions<ExperiencesQuery, ExperiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperiencesQuery, ExperiencesQueryVariables>(ExperiencesDocument, options);
      }
export function useExperiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperiencesQuery, ExperiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperiencesQuery, ExperiencesQueryVariables>(ExperiencesDocument, options);
        }
// @ts-ignore
export function useExperiencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExperiencesQuery, ExperiencesQueryVariables>): Apollo.UseSuspenseQueryResult<ExperiencesQuery, ExperiencesQueryVariables>;
export function useExperiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperiencesQuery, ExperiencesQueryVariables>): Apollo.UseSuspenseQueryResult<ExperiencesQuery | undefined, ExperiencesQueryVariables>;
export function useExperiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperiencesQuery, ExperiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperiencesQuery, ExperiencesQueryVariables>(ExperiencesDocument, options);
        }
export type ExperiencesQueryHookResult = ReturnType<typeof useExperiencesQuery>;
export type ExperiencesLazyQueryHookResult = ReturnType<typeof useExperiencesLazyQuery>;
export type ExperiencesSuspenseQueryHookResult = ReturnType<typeof useExperiencesSuspenseQuery>;
export type ExperiencesQueryResult = Apollo.QueryResult<ExperiencesQuery, ExperiencesQueryVariables>;
export const RegionsDocument = gql`
    query Regions {
  regions {
    default
    id
    name
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
// @ts-ignore
export function useRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegionsQuery, RegionsQueryVariables>): Apollo.UseSuspenseQueryResult<RegionsQuery, RegionsQueryVariables>;
export function useRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsQuery, RegionsQueryVariables>): Apollo.UseSuspenseQueryResult<RegionsQuery | undefined, RegionsQueryVariables>;
export function useRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsSuspenseQueryHookResult = ReturnType<typeof useRegionsSuspenseQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const StatisticDocument = gql`
    query Statistic($adType: AdTypeEnum!) {
  statistic(adType: $adType) {
    month
    week
  }
}
    `;

/**
 * __useStatisticQuery__
 *
 * To run a query within a React component, call `useStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticQuery({
 *   variables: {
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useStatisticQuery(baseOptions: Apollo.QueryHookOptions<StatisticQuery, StatisticQueryVariables> & ({ variables: StatisticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatisticQuery, StatisticQueryVariables>(StatisticDocument, options);
      }
export function useStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatisticQuery, StatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatisticQuery, StatisticQueryVariables>(StatisticDocument, options);
        }
// @ts-ignore
export function useStatisticSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StatisticQuery, StatisticQueryVariables>): Apollo.UseSuspenseQueryResult<StatisticQuery, StatisticQueryVariables>;
export function useStatisticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatisticQuery, StatisticQueryVariables>): Apollo.UseSuspenseQueryResult<StatisticQuery | undefined, StatisticQueryVariables>;
export function useStatisticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatisticQuery, StatisticQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatisticQuery, StatisticQueryVariables>(StatisticDocument, options);
        }
export type StatisticQueryHookResult = ReturnType<typeof useStatisticQuery>;
export type StatisticLazyQueryHookResult = ReturnType<typeof useStatisticLazyQuery>;
export type StatisticSuspenseQueryHookResult = ReturnType<typeof useStatisticSuspenseQuery>;
export type StatisticQueryResult = Apollo.QueryResult<StatisticQuery, StatisticQueryVariables>;
export const SearchSuggestionsDocument = gql`
    query SearchSuggestions($searchTerm: String!, $targetType: AdTypeEnum!) {
  searchSuggestions(searchTerm: $searchTerm, targetType: $targetType) {
    id
    searchTerm
  }
}
    `;

/**
 * __useSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables> & ({ variables: SearchSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, options);
      }
export function useSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, options);
        }
// @ts-ignore
export function useSearchSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>;
export function useSearchSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSuggestionsQuery | undefined, SearchSuggestionsQueryVariables>;
export function useSearchSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, options);
        }
export type SearchSuggestionsQueryHookResult = ReturnType<typeof useSearchSuggestionsQuery>;
export type SearchSuggestionsLazyQueryHookResult = ReturnType<typeof useSearchSuggestionsLazyQuery>;
export type SearchSuggestionsSuspenseQueryHookResult = ReturnType<typeof useSearchSuggestionsSuspenseQuery>;
export type SearchSuggestionsQueryResult = Apollo.QueryResult<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>;
export const SeoMetadataDocument = gql`
    query SeoMetadata($adId: ID, $adType: AdTypeEnum!, $filters: AdFilter) {
  seoMetadata(adId: $adId, adType: $adType, filters: $filters) {
    title
    description
    breadcrumbs {
      id
      name
      position
      type
    }
  }
}
    `;

/**
 * __useSeoMetadataQuery__
 *
 * To run a query within a React component, call `useSeoMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoMetadataQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *      adType: // value for 'adType'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSeoMetadataQuery(baseOptions: Apollo.QueryHookOptions<SeoMetadataQuery, SeoMetadataQueryVariables> & ({ variables: SeoMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeoMetadataQuery, SeoMetadataQueryVariables>(SeoMetadataDocument, options);
      }
export function useSeoMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeoMetadataQuery, SeoMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeoMetadataQuery, SeoMetadataQueryVariables>(SeoMetadataDocument, options);
        }
// @ts-ignore
export function useSeoMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SeoMetadataQuery, SeoMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<SeoMetadataQuery, SeoMetadataQueryVariables>;
export function useSeoMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeoMetadataQuery, SeoMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<SeoMetadataQuery | undefined, SeoMetadataQueryVariables>;
export function useSeoMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeoMetadataQuery, SeoMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeoMetadataQuery, SeoMetadataQueryVariables>(SeoMetadataDocument, options);
        }
export type SeoMetadataQueryHookResult = ReturnType<typeof useSeoMetadataQuery>;
export type SeoMetadataLazyQueryHookResult = ReturnType<typeof useSeoMetadataLazyQuery>;
export type SeoMetadataSuspenseQueryHookResult = ReturnType<typeof useSeoMetadataSuspenseQuery>;
export type SeoMetadataQueryResult = Apollo.QueryResult<SeoMetadataQuery, SeoMetadataQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories {
  categories {
    id
    name
    parentId
    children {
      id
      name
      parentId
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery | undefined, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const RegionsQueryDocument = gql`
    query RegionsQuery {
  regions {
    id
    name
    default
  }
}
    `;

/**
 * __useRegionsQueryQuery__
 *
 * To run a query within a React component, call `useRegionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQueryQuery, RegionsQueryQueryVariables>(RegionsQueryDocument, options);
      }
export function useRegionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQueryQuery, RegionsQueryQueryVariables>(RegionsQueryDocument, options);
        }
// @ts-ignore
export function useRegionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RegionsQueryQuery, RegionsQueryQueryVariables>;
export function useRegionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RegionsQueryQuery | undefined, RegionsQueryQueryVariables>;
export function useRegionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsQueryQuery, RegionsQueryQueryVariables>(RegionsQueryDocument, options);
        }
export type RegionsQueryQueryHookResult = ReturnType<typeof useRegionsQueryQuery>;
export type RegionsQueryLazyQueryHookResult = ReturnType<typeof useRegionsQueryLazyQuery>;
export type RegionsQuerySuspenseQueryHookResult = ReturnType<typeof useRegionsQuerySuspenseQuery>;
export type RegionsQueryQueryResult = Apollo.QueryResult<RegionsQueryQuery, RegionsQueryQueryVariables>;
export const SitemapDocument = gql`
    query Sitemap {
  sitemap {
    name
    records {
      id
      lastmod
    }
  }
}
    `;

/**
 * __useSitemapQuery__
 *
 * To run a query within a React component, call `useSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitemapQuery(baseOptions?: Apollo.QueryHookOptions<SitemapQuery, SitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, options);
      }
export function useSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapQuery, SitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, options);
        }
// @ts-ignore
export function useSitemapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitemapQuery, SitemapQueryVariables>): Apollo.UseSuspenseQueryResult<SitemapQuery, SitemapQueryVariables>;
export function useSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapQuery, SitemapQueryVariables>): Apollo.UseSuspenseQueryResult<SitemapQuery | undefined, SitemapQueryVariables>;
export function useSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapQuery, SitemapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, options);
        }
export type SitemapQueryHookResult = ReturnType<typeof useSitemapQuery>;
export type SitemapLazyQueryHookResult = ReturnType<typeof useSitemapLazyQuery>;
export type SitemapSuspenseQueryHookResult = ReturnType<typeof useSitemapSuspenseQuery>;
export type SitemapQueryResult = Apollo.QueryResult<SitemapQuery, SitemapQueryVariables>;
export const DraftVacancyDocument = gql`
    query DraftVacancy {
  draftVacancy {
    ...vacancyFields
  }
}
    ${VacancyFieldsFragmentDoc}`;

/**
 * __useDraftVacancyQuery__
 *
 * To run a query within a React component, call `useDraftVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftVacancyQuery({
 *   variables: {
 *   },
 * });
 */
export function useDraftVacancyQuery(baseOptions?: Apollo.QueryHookOptions<DraftVacancyQuery, DraftVacancyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftVacancyQuery, DraftVacancyQueryVariables>(DraftVacancyDocument, options);
      }
export function useDraftVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftVacancyQuery, DraftVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftVacancyQuery, DraftVacancyQueryVariables>(DraftVacancyDocument, options);
        }
// @ts-ignore
export function useDraftVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DraftVacancyQuery, DraftVacancyQueryVariables>): Apollo.UseSuspenseQueryResult<DraftVacancyQuery, DraftVacancyQueryVariables>;
export function useDraftVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftVacancyQuery, DraftVacancyQueryVariables>): Apollo.UseSuspenseQueryResult<DraftVacancyQuery | undefined, DraftVacancyQueryVariables>;
export function useDraftVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftVacancyQuery, DraftVacancyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftVacancyQuery, DraftVacancyQueryVariables>(DraftVacancyDocument, options);
        }
export type DraftVacancyQueryHookResult = ReturnType<typeof useDraftVacancyQuery>;
export type DraftVacancyLazyQueryHookResult = ReturnType<typeof useDraftVacancyLazyQuery>;
export type DraftVacancySuspenseQueryHookResult = ReturnType<typeof useDraftVacancySuspenseQuery>;
export type DraftVacancyQueryResult = Apollo.QueryResult<DraftVacancyQuery, DraftVacancyQueryVariables>;
export const VacancyDocument = gql`
    query Vacancy($id: ID!) {
  vacancy(id: $id) {
    ...vacancyFields
  }
}
    ${VacancyFieldsFragmentDoc}`;

/**
 * __useVacancyQuery__
 *
 * To run a query within a React component, call `useVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVacancyQuery(baseOptions: Apollo.QueryHookOptions<VacancyQuery, VacancyQueryVariables> & ({ variables: VacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
      }
export function useVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
// @ts-ignore
export function useVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>): Apollo.UseSuspenseQueryResult<VacancyQuery, VacancyQueryVariables>;
export function useVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>): Apollo.UseSuspenseQueryResult<VacancyQuery | undefined, VacancyQueryVariables>;
export function useVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
export type VacancyQueryHookResult = ReturnType<typeof useVacancyQuery>;
export type VacancyLazyQueryHookResult = ReturnType<typeof useVacancyLazyQuery>;
export type VacancySuspenseQueryHookResult = ReturnType<typeof useVacancySuspenseQuery>;
export type VacancyQueryResult = Apollo.QueryResult<VacancyQuery, VacancyQueryVariables>;
export const GetVacancyDocument = gql`
    query GetVacancy($id: ID!) {
  vacancy(id: $id) {
    ...BaseVacancyFields
  }
}
    ${BaseVacancyFieldsFragmentDoc}`;

/**
 * __useGetVacancyQuery__
 *
 * To run a query within a React component, call `useGetVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVacancyQuery(baseOptions: Apollo.QueryHookOptions<GetVacancyQuery, GetVacancyQueryVariables> & ({ variables: GetVacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVacancyQuery, GetVacancyQueryVariables>(GetVacancyDocument, options);
      }
export function useGetVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVacancyQuery, GetVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVacancyQuery, GetVacancyQueryVariables>(GetVacancyDocument, options);
        }
// @ts-ignore
export function useGetVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVacancyQuery, GetVacancyQueryVariables>): Apollo.UseSuspenseQueryResult<GetVacancyQuery, GetVacancyQueryVariables>;
export function useGetVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVacancyQuery, GetVacancyQueryVariables>): Apollo.UseSuspenseQueryResult<GetVacancyQuery | undefined, GetVacancyQueryVariables>;
export function useGetVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVacancyQuery, GetVacancyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVacancyQuery, GetVacancyQueryVariables>(GetVacancyDocument, options);
        }
export type GetVacancyQueryHookResult = ReturnType<typeof useGetVacancyQuery>;
export type GetVacancyLazyQueryHookResult = ReturnType<typeof useGetVacancyLazyQuery>;
export type GetVacancySuspenseQueryHookResult = ReturnType<typeof useGetVacancySuspenseQuery>;
export type GetVacancyQueryResult = Apollo.QueryResult<GetVacancyQuery, GetVacancyQueryVariables>;
export const GetFeaturedVacanciesDocument = gql`
    query GetFeaturedVacancies {
  vacancies(scope: FEATURED, filter: {random: true}, first: 8) {
    edges {
      node {
        ...vacancyCardFields
      }
    }
  }
}
    ${VacancyCardFieldsFragmentDoc}`;

/**
 * __useGetFeaturedVacanciesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedVacanciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>(GetFeaturedVacanciesDocument, options);
      }
export function useGetFeaturedVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>(GetFeaturedVacanciesDocument, options);
        }
// @ts-ignore
export function useGetFeaturedVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>;
export function useGetFeaturedVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeaturedVacanciesQuery | undefined, GetFeaturedVacanciesQueryVariables>;
export function useGetFeaturedVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>(GetFeaturedVacanciesDocument, options);
        }
export type GetFeaturedVacanciesQueryHookResult = ReturnType<typeof useGetFeaturedVacanciesQuery>;
export type GetFeaturedVacanciesLazyQueryHookResult = ReturnType<typeof useGetFeaturedVacanciesLazyQuery>;
export type GetFeaturedVacanciesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedVacanciesSuspenseQuery>;
export type GetFeaturedVacanciesQueryResult = Apollo.QueryResult<GetFeaturedVacanciesQuery, GetFeaturedVacanciesQueryVariables>;